import React, {useEffect, useCallback, useContext, useState} from 'react'
import * as yup from 'yup'
import {yupResolver} from '@hookform/resolvers/yup'
import {useForm} from 'react-hook-form'
import {useAuthClient} from '../utils/use-auth-client'
import AsyncSelect from 'react-select/async'
import {useUserFeatures} from '../context/user-features-context'
import {
  // Input,
  // Button,
  ParagraphText,
  Icon,
  Timeline,
  Modal,
} from '@thryvlabs/maverick'
import {toast} from 'react-toastify'
import {useAuth0} from '@auth0/auth0-react'
import {
  BC_PLANS,
  BILLING_PREFERENCES,
  MC_PLANS,
  MC_2_0_PLANS,
  CC_CURRENCIES,
  COUNTRIES,
  KEAP_FAMILY_CODES,
  SOCIAL_ADS_4_CODES,
} from '../utils/constants'
import {NewOrderLayout} from '../components/new-order-layout'
import {CartPaymentDetails} from '../components/cart-payment-details'
import {AccountInfoBanner} from '../components/account-info-banner'
import {PhoneNumberUtil} from 'google-libphonenumber'
import {useLocation} from 'react-router'
import {headerContext} from '../context/header-context'
import {useUserRoles} from '../utils/use-user-roles'

import {
  CouponContainer,
  SendPaymentLinkText,
  TimelineContainer,
  BillingPromptContainer,
} from '../components/ui/payment-details'
import CountdownTimer from '../components/countdown-timer'
import dayjs from 'dayjs'
import io from 'socket.io-client'
import {getUpgradeIncentivePlans} from '../utils/incentives'
import {TransitionContainer} from '../components/ui/cartProducts'
import {Spinner} from '../components/loader-spinner'
import {PlanComparisonDetails} from '../components/plan-comparison-details'
import {useNavigate} from 'react-router-dom'
import {CcSidebar} from '../components/cc-sidebar'
import {ADD_ON} from '../utils/addons-data'
import {useAsync} from '../utils/use-async'
import PaymentLink from '../components/payment-link'
// import {CC_PLANS, TRANSITION_INCENTIVES} from '../utils/constants'
import {BillingOptionsModal} from '../components/billing-options-modal'
import getPreviewItemTotal from '../utils/get-preview-item-total'
import {formatPrice} from '../utils/currency-format'
import {useSelector, useDispatch, useStore, shallowEqual} from 'react-redux'

import {
  selectManualCoupons,
  selectAutoCoupons,
  selectDefaultCoupons,
  selectMergedCoupons,
  selectUpgradePaymentPreview,
  setMergedCoupons,
  setAutoCoupons,
} from '../app-store/coupon'
import {OOE_SERVICE_URL as REACT_APP_OOE_SERVICE_URL} from '../utils/api-base'

const autoPayTimeline = [
  {
    eventTitle: <p>Payment Link Sent</p>,
    eventSubtitle: '',
    theme: 'neutral',
  },
  {
    eventTitle: <p>Client clicked link from email</p>,
    eventSubtitle: '',
    theme: 'neutral',
  },
  {
    eventTitle: <p>Payment Method Added</p>,
    eventSubtitle: '',
    theme: 'neutral',
  },
  {
    eventTitle: <p>Order Completed</p>,
    eventSubtitle: '',
    theme: 'neutral',
  },
]

const invoiceTimeline = [
  {
    eventTitle: <p>Invoice Link Sent</p>,
    eventSubtitle: '',
    theme: 'neutral',
  },
  {
    eventTitle: <p>Client Clicked Link</p>,
    eventSubtitle: '',
    theme: 'neutral',
  },
  {
    eventTitle: <p>Billing Address Updated</p>,
    eventSubtitle: '',
    theme: 'neutral',
  },
  {
    eventTitle: <p>Proceed with Order</p>,
    eventSubtitle: '',
    theme: 'neutral',
  },
]

const phoneUtil = PhoneNumberUtil.getInstance()

const SCHEMA = yup.object().shape({
  smsContact: yup
    .string()
    .required('This field is required')
    .test(
      'validate-phone-format',
      'Incorrect phone number format',
      function (value) {
        try {
          if (!value) {
            return false
          }
          const country = this.options.context.componentProps.countryIsoValue
          value = value.replace(/[^\d]/g, '')
          const parsedPhone = phoneUtil.parse(value, country)
          return phoneUtil.isValidNumber(parsedPhone)
        } catch {
          return false
        }
      },
    ),
})

const PaymentDetails = ({
  nextStep,
  prevStep,
  selectedAddons,
  sendPaymentLink,
  resendPaymentLink,
  checkClientEmailStatus,
  showSmsOption,
  setShwoSmsOption,
  accountInformation,
  accountSubscriptionData,
  countryIsoValue,
  selectedCountry,
  kickoffApptId,
  creativeApptId,
  thryvSuccessServicesApptId,
  setCreativeApptId,
  setKickoffApptId,
  setThryvSuccessServicesApptId,
  accountInfo,
  selectedPlan,
  cartProducts,
  setCartProducts,
  currentStep,
  processing,
  setProcessing,
  setCreativeCallDate,
  setOnboardingCallDate,
  setThryvSuccessServicesCallDate,
  clientEmail,
  onboardingCallDate,
  creativeCallDate,
  thryvSuccessServicesCallDate,
  selectedCentersAndApps,
  sendCCPaymentLink,
  isCCPlan,
  defaultCentersAndApps,
  isSEOIncluded,
  allowInvoice,
  setSelectedPaymentMethod,
  selectedPaymentMethod,
  previewRequestFinished,
  isCohort,
  cohortEaid,
  orderData5CU,
  orderData4CU,
  order5NUId,
  isCancelOrder5,
  cancelOrder5,
  updateApptOnExpire,
  captureOrder4NewUpgrade,
  isWebsiteValid,
  isNewTLMCAccessible,
  keapAccount = false,
  isBillingNoticeDisplayed,
  setIsBillingNoticeDisplayed,
  all5PlanPrices,
  order,
  keapTrailAppId,
  setKeapTrailAppId,
  keapTextVoiceQty,
  keapAddContactsQty,
  getLegacyPaymentPreview,
  keapAddContactsQtyAnnual,
  keapTextVoiceQtyAnnual,
  keapAddContactsQtyGraphlyAnnual,
  plusThisPremiumQtyGraphlyAnnual,
}) => {
  const {user} = useAuth0()
  const {roles} = useUserRoles()
  const {pathname} = useLocation()

  const couponDispatch = useDispatch()
  const couponStore = useStore()
  const ccCouponInfo = useSelector(selectManualCoupons, shallowEqual)
  const autoCouponInfo = useSelector(selectAutoCoupons, shallowEqual)
  const defaultCouponInfo = useSelector(selectDefaultCoupons, shallowEqual)
  const orderCouponCodes = useSelector(selectMergedCoupons, shallowEqual)
  const upgradePaymentPreview = useSelector(selectUpgradePaymentPreview)

  const setOrderCouponCodes = useCallback(
    valueOrUpdater => {
      if (typeof valueOrUpdater === 'function') {
        const current = couponStore.getState().ccCouponState.mergedCoupons
        couponDispatch(setMergedCoupons(valueOrUpdater(current)))
      } else {
        couponDispatch(setMergedCoupons(valueOrUpdater))
      }
    },
    [couponDispatch, couponStore],
  )

  const [contactMethod, setContactMethod] = useState('email')
  const [couponCode, setCouponCode] = useState('')
  const [isCouponCodeValid, setIsCouponCodeValid] = useState(false)
  const [couponInfo, setCouponInfo] = useState([])
  const [autoCouponDiscount, setAutoCouponDiscount] = useState(0)
  const [hideCouponInput, setHideCouponInput] = useState(false)
  const [monthlyBilling, setMonthlyBilling] = useState(false)
  const [monthlyTotal, setMonthlyTotal] = useState()
  const [semiAnnuallyBilling, setSemiAnnuallyBilling] = useState(false)
  const [semiAnnuallyTotal, setSemiAnnuallyTotal] = useState()
  const [monthlyPayDate, setMonthlyPayDate] = useState()
  const [semiAnnuallyPayDate, setSemiAnnuallyPayDate] = useState()
  const [totalPrice, setTotalPrice] = useState(0)
  const [currentPrice, setCurrentPrice] = useState(0)
  const [totalCcPrice, setTotalCcPrice] = useState(0)
  const [discountAmount, setDiscountAmount] = useState(0)
  const [partnerOpsGeneratedUrl, setPartnerOpsGeneratedUrl] = useState('')
  // const [discountArray] = useState([])
  const [uuid, setUuid] = useState()
  const [shortenedUrl, setShortenedUrl] = useState(null)
  const [orderId, setOrderId] = useState()
  const isNewOrder = pathname === '/order/new'
  const [orderCompleted, setOrderCompleted] = useState(false)
  const [processingMessage, setProcessingMessage] = useState(false)
  const [isLinkSent, setIsLinkSent] = useState(false)
  const [sendLinkError, setSendLinkError] = useState(false)
  const [ccTotal, setCcTotal] = useState(0)
  const [nextAmountDue, setNextAmountDue] = useState(0)
  const [softwareUpgraded, setSoftwareUpgraded] = useState(false)
  const [bypassSms, setBypassSms] = useState(false)
  const [showEmailStatusLinkOption, setShowEmailStatusLinkOption] =
    useState(false)
  const [showProcessPurchaseErrorModal, setShowProcessPurchaseErrorModal] =
    useState(false)
  const [processPurchaseErrorMessage, setProcessPurchaseErrorMessage] =
    useState('')
  const VALIDITY_IN_HOUR_IN_MS = 3601000
  const [linkExpiryInMinutes, setLinkExpiryInMinutes] = useState(
    VALIDITY_IN_HOUR_IN_MS,
  )
  const [isAppointmentExpired, setIsAppointmentExpired] = useState(false)
  // const TIMESTAMP_60_MINUTES_FROM_NOW = useRef(dayjs() + 3601000)
  const {isHeaderVisible, setIsHeaderVisible} = useContext(headerContext)
  const [maxAllowedCoupons, setMaxAllowedCoupons] = useState(0)
  const [showBillingModal, setShowBillingModal] = useState(true)
  const client = useAuthClient()
  const userFeatures = useUserFeatures()
  const navigate = useNavigate()
  const {
    Frontend_Side_Nav: frontendSideNav,
    Frontend_Cohort_Release: frontendCohortRelease,
    Listings_BC_MC: frontendListingsBcMc,
  } = useUserFeatures()
  const isUpgrade = pathname === '/order/upgrade'
  const {handleSubmit} = useForm({
    mode: 'onSubmit',
    defaultValues: {
      smsContact: accountInformation.mobile,
    },
    reValidateMode: 'onChange',
    resolver: yupResolver(SCHEMA),
    context: {componentProps: {countryIsoValue}},
  })
  const {run} = useAsync({
    status: 'pending',
  })

  const transitionOrder = autoCouponInfo.some(
    ({description}) =>
      description === 'Transition Incentive' ||
      description === 'Transition Coupon',
  )
  const eligibleTransitionCenters =
    !isNewOrder &&
    selectedCentersAndApps &&
    getUpgradeIncentivePlans(
      selectedCentersAndApps.centers,
      defaultCentersAndApps.centers,
      upgradePaymentPreview,
    )
  const stringifiedEligibleTransitionCenters = JSON.stringify(
    eligibleTransitionCenters,
  )
  const isAus = countryIsoValue === 'AU'
  const isNZ = countryIsoValue === 'NZ'

  const KCP_AU_QTY_MAPPING = [
    {amount: 418, qty: 380},
    {amount: 704, qty: 640},
    {amount: 1001, qty: 910},
    {amount: 2002, qty: 1820},
  ]

  const handleCouponCodeChange = e => {
    // const {value} = e.target
    setCouponCode(e.value)
  }

  const loadOptions = (inputValue, callback) => {
    if (inputValue && inputValue.length >= 3) {
      fetchNameOptions(inputValue).then(options => {
        callback(options)
      })
    } else if (!inputValue) {
      callback([])
    }
  }

  const fetchNameOptions = async inputValue => {
    const response = await client(
      `cc/order/fetchCoupons/${selectedCountry}/${inputValue}`,
    )

    return response.map(item => ({
      label: item.coupon_code,
      value: item.coupon_code,
      autoCoupon: item.autoAddCoupons,
      autoCouponProds: item.requiredProducts,
      incompatibles: item.incompatibles,
      bundle_combinations: item.bundle_combinations,
    }))
  }

  const addonsPrice =
    Number(cartProducts?.find(x => x.product === 'Addons')?.price?.slice(1)) ||
    0
  const monthlyPrice =
    addonsPrice +
    Number(cartProducts[0]?.price.slice(1).replace(/[$,a-zA-Z]/g, ''))
  const mcInAddonsPrice = selectedAddons?.find(x =>
    ADD_ON.add_ons['Marketing Center Plus'].addOnCodes.includes(x.planCode),
  )
  const incentiveEligibleCart =
    (selectedPlan?.name?.includes('sync')
      ? 0
      : Number(cartProducts[0]?.price.replace(/[$,a-zA-Z]/g, ''))) +
    (Number(mcInAddonsPrice?.price.replace(/[$,a-zA-Z]/g, '')) || 0)

  const validateCoupon = async () => {
    // fetch the max number of manual coupons allowed
    const response = await client(
      'keappartner/fetchConfigLookupValue/maxAllowedManualCoupons',
    )
    const maxAllowedCoupons = response?.data[0]?.value
    console.log('maxAllowedCoupons :: ', maxAllowedCoupons)

    if (!couponInfo || (couponInfo && couponInfo.length < maxAllowedCoupons)) {
      // fetch coupon configuration from OOE table.
      const response = await client(
        `cc/order/fetchCoupons/${selectedCountry}/${couponCode.trim()}`,
      )
      const couponConfigInfo = response[0]
      if (couponConfigInfo) {
        let recurlyValidationError = false
        // order?.thryId is the wrong id that was being passed to coupon-redemption
        const thryvIdForCoupon =
          accountInfo?.thryvID || order.CCAccountInfo?.thryvId || order?.thryvId
        if (thryvIdForCoupon) {
          // Fetch the active coupon redemptions from recurly
          const existingCoupons = await client(
            `accounts/5/coupon-redemptions?thryvId=${thryvIdForCoupon}`,
          )
          const activeCouponCodes = existingCoupons.map(coupon => coupon.code)
          console.log('activeCouponCodes : ', activeCouponCodes)
          // Check if coupon being applied is already applied in recurly
          if (activeCouponCodes.includes(couponCode.trim())) {
            toast.error(
              "Oops! Looks like these coupons are already applied to the client's account, so they'll be removed from this order. Don't worry, the right discounts will still apply when their payment is processed",
            )
            recurlyValidationError = true
          }
          // Check if coupon being applied is incompatible with any already applied coupon in recurly
          const incompatibleCoupons = couponConfigInfo.incompatibles?.split(',')
          if (
            incompatibleCoupons &&
            incompatibleCoupons.length > 0 &&
            incompatibleCoupons.some(incompatibleCoupon =>
              activeCouponCodes.includes(incompatibleCoupon),
            )
          ) {
            toast.error(
              'The coupon you are trying to apply can not be combined with an existing coupon on your account. Coupon not applied.',
            )
            recurlyValidationError = true
          }
        }
        if (!recurlyValidationError) {
          const addonsString = selectedAddons
            .filter(addon => addon.planCode !== undefined)
            .map(addon => addon.planCode)
          if (
            couponCode &&
            couponInfo &&
            !couponInfo.find(coupon => coupon.code === couponCode)
          ) {
            if (
              couponConfigInfo.bundle_combinations &&
              couponConfigInfo.bundle_combinations.length > 0
            ) {
              let isValidBundle = false
              for (const bundleCombination of couponConfigInfo.bundle_combinations) {
                const requiredCodes = bundleCombination.split(',')
                const allCodesPresent = requiredCodes.every(code =>
                  addonsString.includes(code),
                )
                if (allCodesPresent) {
                  isValidBundle = true
                  break
                }
              }
              if (!isValidBundle) {
                // toast.warn(
                //   'Oops! Some items in your cart don't qualify for this bundle coupon. Please update your cart to continue.',
                //   {autoClose: false},
                // )
                alert(
                  "Oops! Some items in your cart don't qualify for this bundle coupon. Please update your cart to continue.",
                )
                // return
              }
            }
            // setCouponCode(couponCode.trim())
            try {
              let url = `orders/coupon/validate?couponCode=${couponCode}&country=${countryIsoValue}&planCode=${accountInformation.package}`
              if (addonsString.length > 0) {
                url = `${url}&addonsString=${addonsString}`
              }
              const response = await client(url)
              setIsCouponCodeValid(response.isValid)
              if (response.isValid) {
                const incompatibleCodes =
                  couponConfigInfo.incompatibles?.split(',') ?? []
                const removedCodes = couponInfo
                  .filter(coupon => incompatibleCodes.includes(coupon.code))
                  .map(coupon => coupon.code)
                if (removedCodes.length > 0) {
                  toast.info(
                    `${removedCodes.join(
                      ', ',
                    )} can't be combined with ${couponCode.trim()} and was removed.`,
                  )
                }
                const nextCoupons = [
                  ...couponInfo.filter(
                    coupon =>
                      !couponConfigInfo.incompatibles
                        ?.split(',')
                        .includes(coupon.code),
                  ),
                  {...response, ...couponConfigInfo, code: couponCode.trim()},
                ]
                setCouponInfo(nextCoupons)
                captureOrderDiscounts([response])
                setOrderCouponCodes(current =>
                  removeDuplicatesFromArray(
                    [
                      ...current.filter(
                        coupon =>
                          !couponConfigInfo.incompatibles
                            ?.split(',')
                            .includes(coupon.code),
                      ),
                      {
                        ...response,
                        ...couponConfigInfo,
                        code: couponCode.trim(),
                      },
                    ],
                    'code',
                  ),
                )
                getLegacyPaymentPreview?.(nextCoupons.map(c => c.code))
              } else {
                toast.error('Invalid coupon.')
              }
            } catch (error) {
              if (error.status === 404) {
                toast.error('Invalid coupon.')
                setIsCouponCodeValid(false)
                // setCouponInfo({isValid: false})
              }
            }
          }
        }
      } else {
        toast.error('Unable to fetch coupon configuration, Invalid coupon.')
      }
    }
  }

  const captureOrderDiscounts = async discountData => {
    // Only capture discounts if order5NUId is available
    if (!order5NUId) {
      console.log('order5NUId not available yet, skipping discount capture')
      return
    }
    const allDiscount = []
    let lineCounter = 1
    for (const data of discountData) {
      const dataObj = {
        order_id: order5NUId,
        line_number: lineCounter,
        discount_type: data.type,
        coupon_code: data.code,
        discount_percentage: data.discountPercent,
        discount_amount: data.discountAmount,
        number_of_months: data.durationAmount + data.durationUnit,
        start_date: new Date(),
        end_date: datePlusDuration(
          new Date(),
          data.durationAmount,
          data.durationUnit,
        ),
        created_date: '2024-08-19T18:30:00.000Z',
        create_oprid: null,
        updated_date: '2024-08-19T18:30:00.000Z',
        update_oprid: null,
      }
      allDiscount.push(dataObj)
      lineCounter = lineCounter + 1
    }
    console.log('all Discounts', allDiscount)
    captureOrder4NewUpgrade('apply-coupon', 'new-upgrade', allDiscount)
  }

  function datePlusDuration(date, duration, unit) {
    const newDate = new Date(date)
    if (unit === 'month') newDate.setMonth(newDate.getMonth() + duration)
    if (unit === 'day') newDate.setDate(newDate.getDate() + duration)
    if (unit === 'year') newDate.setFullYear(newDate.getFullYear() + duration)
    return newDate
  }

  const getTotalPrice = products => {
    let totalPrice = 0
    for (const i in products) {
      if (products[i].code !== '247support-m2m') {
        if (!isNewOrder && products[i].billingPreference === 'oneTime') {
          continue
        }
        if (typeof products[i].price === 'string') {
          totalPrice +=
            parseFloat(products[i].price.replace(/[$,a-zA-Z]/g, '')).toFixed(
              2,
            ) * 1
        } else {
          totalPrice += products[i].price
        }
      }
    }
    if (accountInfo?.balanceInfo?.availableCreditAmount) {
      totalPrice = totalPrice + accountInfo?.balanceInfo?.availableCreditAmount
    }
    return totalPrice > 0 ? totalPrice : 0
  }
  const getListOfAddons = data => {
    const isNewSEOAdded = data.find(item =>
      ['SEO Keyword', 'AEO & SEO', 'AEO & SEO PowerBoost'].includes(
        item?.product.trim(' '),
      ),
    )
    if (isNewSEOAdded) {
      data = data.filter(
        item =>
          !['SEO Money Back Guarantee', 'SEO Non-Guaranteed'].includes(
            item.product,
          ),
      )
    }
    return data
  }
  const removeDuplicatesFromArray = (arrayObject, comparisionAttribute) => {
    const uniqueArrayElements = new Set()
    return arrayObject.filter(item => {
      const keyValue = item[comparisionAttribute]
      return uniqueArrayElements.has(keyValue)
        ? false
        : (uniqueArrayElements.add(keyValue), true)
    })
  }
  const formatCenters = (centers, callbackFn) =>
    centers
      .filter(callbackFn)
      .map(
        ({
          code,
          quantity = 1,
          entitlements,
          startDate,
          amount,
          alreadyIncluded,
          tempLineActionCode,
        }) => {
          const isMCInCart = centers.find(
            ({code, tempLineActionCode}) =>
              MC_PLANS.includes(code) && tempLineActionCode === 'New',
          )
          if (
            isNewTLMCAccessible &&
            code.startsWith('tl-') &&
            tempLineActionCode === 'New'
          ) {
            code = 'tl-tax-5-thryv-m2m'
          } else if (
            code.includes('addon-4-tl') &&
            tempLineActionCode === 'New' &&
            userFeatures?.TL_Tax_Plan_Enabled
          ) {
            code = 'addon-4-tl-tax-m2m'
          } else if (isNewTLMCAccessible && isMCInCart) {
            if (code.includes('tl-5-')) {
              code = 'tl-mc-5-thryv-m2m'
            }
            if (code.includes('addon-4-tl')) {
              code = 'addon-4-tl-mc-m2m'
            }
          }
          return {
            code,
            quantity,
            amount,
            isAlreadyAdded: !!(alreadyIncluded && alreadyIncluded === true),
            ...(startDate && new Date(startDate) >= new Date() && {startDate}),
            addons: entitlements?.map(
              ({code, alreadyIncluded, name, quantity}) => {
                // const entitlementQuantity =
                //   code === 'ent-keap-included-contacts'
                //     ? 1500
                //     : code === 'ent-keap-included-user'
                //     ? 2
                //     : 1
                return {
                  isAlreadyAdded: !!(
                    alreadyIncluded && alreadyIncluded === true
                  ),
                  code,
                  quantity: quantity ?? 1,
                  name,
                }
              },
            ),
          }
        },
      )

  const formatApps = (apps, callbackFn) =>
    apps
      .filter(callbackFn)
      .map(
        ({
          code,
          quantity = 1,
          alreadyIncluded,
          amount,
          unitAmount,
          tempLineActionCode,
        }) => {
          const isMCInCart = selectedCentersAndApps?.centers.find(
            ({code, tempLineActionCode}) =>
              MC_PLANS.includes(code) && tempLineActionCode === 'New',
          )
          if (
            isNewTLMCAccessible &&
            code.startsWith('tl-') &&
            tempLineActionCode === 'New'
          ) {
            code = 'tl-tax-5-thryv-m2m'
          } else if (
            code.includes('addon-4-tl') &&
            tempLineActionCode === 'New' &&
            userFeatures?.TL_Tax_Plan_Enabled
          ) {
            code = 'addon-4-tl-tax-m2m'
          } else if (isNewTLMCAccessible && isMCInCart) {
            if (code.includes('tl-5-')) {
              code = 'tl-mc-5-thryv-m2m'
            }
            if (code.includes('addon-4-tl')) {
              code = 'addon-4-tl-mc-m2m'
            }
          }
          return {
            isAlreadyAdded:
              alreadyIncluded && alreadyIncluded === true ? true : false,
            code,
            amount,
            quantity,
            unitAmount: Number(unitAmount ?? amount ?? 0),
            addons: [],
          }
        },
      )

  const findWebsiteEntitlement = centers =>
    centers
      .find(({entitlements}) =>
        entitlements?.some(
          ({name}) => name === 'Professionally Designed Website',
        ),
      )
      ?.entitlements?.find(
        ({name}) => name === 'Professionally Designed Website',
      )

  const findWebsiteApp = ({name}) => name === 'Professionally Designed Website'
  useEffect(() => {
    const fetchMaxAllowedCoupons = async () => {
      // fetch the max number of manual coupons allowed
      const response = await client(
        'keappartner/fetchConfigLookupValue/maxAllowedManualCoupons',
      )
      setMaxAllowedCoupons(response?.data[0]?.value)
      console.log('maxAllowedCoupons :: ', maxAllowedCoupons)
    }

    fetchMaxAllowedCoupons()
  }, [client, maxAllowedCoupons])

  useEffect(() => {
    async function fetchLinkExpiryTimeCountDetails() {
      const response = await run(
        client('keappartner/fetchConfigLookupValue/MainAppLinkExpiryInMinutes'),
      )
      if (response?.data.length) {
        setLinkExpiryInMinutes(Number(response.data[0].value) || 0)
      }
    }
    fetchLinkExpiryTimeCountDetails()
  }, [selectedCentersAndApps, order5NUId])

  useEffect(() => {
    if (selectedCentersAndApps) return
    let currentTotal = getTotalPrice(getListOfAddons(selectedAddons))

    // Remove the auto coupons if it is incompatible with any of the applied manual coupons
    let filteredAutocoupons = []
    if (couponInfo && couponInfo.length > 0) {
      filteredAutocoupons = autoCouponInfo.filter(autoCoupon => {
        const incompatibleCoupons = couponInfo.flatMap(
          coupon => coupon?.incompatibles?.split(',') || [],
        )
        return !incompatibleCoupons.includes(autoCoupon.code)
      })
    } else {
      filteredAutocoupons = [...autoCouponInfo]
    }

    let newAutoCouponDiscount = 0
    let newDiscountAmount = 0
    filteredAutocoupons.forEach(coupon => {
      if (coupon.discountAmount) {
        newAutoCouponDiscount += coupon.discountAmount
      } else if (coupon.discountPercent && coupon.appliesToAllPlans) {
        selectedAddons.forEach(addon => {
          if (!addon.planCode.includes('setupfee')) {
            newAutoCouponDiscount +=
              Number(addon.price.replace(/[^0-9.]/g, '')) *
              (coupon.discountPercent / 100)
          }
        })
      } else {
        selectedAddons.forEach(addon => {
          if (
            coupon?.appliesToPlans?.includes(addon.planCode) &&
            !addon.planCode.includes('setupfee')
          ) {
            newAutoCouponDiscount +=
              Number(addon.price.replace(/[^0-9.]/g, '')) *
              (coupon.discountPercent / 100)
          }
        })
      }
    })

    for (const coupon of couponInfo) {
      if (coupon.discountAmount) {
        newDiscountAmount += coupon.discountAmount
      } else if (coupon.discountPercent && coupon.appliesToAllPlans) {
        selectedAddons.forEach(addon => {
          if (!addon.planCode.includes('setupfee')) {
            newDiscountAmount +=
              Number(addon.price.replace(/[^0-9.]/g, '')) *
              (coupon.discountPercent / 100)
          }
        })
        currentTotal -= newDiscountAmount
      } else {
        selectedAddons.forEach(addon => {
          if (
            coupon?.appliesToPlans?.includes(addon.planCode) &&
            !addon.planCode.includes('setupfee')
          ) {
            newDiscountAmount +=
              Number(addon.price.replace(/[^0-9.]/g, '')) *
              (coupon.discountPercent / 100)
          }
        })
      }
    }

    setOrderCouponCodes(
      removeDuplicatesFromArray(
        [
          ...[
            ...filteredAutocoupons,
            ...ccCouponInfo,
            // ccCouponInfo?.isValid ? ccCouponInfo : null,
            // couponInfo?.isValid ? couponInfo : null,
            ...couponInfo,
          ].filter(Boolean),
          ...(defaultCouponInfo || null),
        ],
        'code',
      ),
    )
    const newTotalPrice = parseFloat(
      Math.max(currentTotal - newDiscountAmount - newAutoCouponDiscount, 0),
    )

    setAutoCouponDiscount(newAutoCouponDiscount)
    setDiscountAmount(newDiscountAmount)
    setTotalPrice(newTotalPrice)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    autoCouponInfo,
    client,
    countryIsoValue,
    couponInfo,
    defaultCouponInfo,
    couponInfo.discountAmount,
    couponInfo.discountPercent,
    couponInfo.isPercentDiscount,
    couponInfo.isValid,
    discountAmount,
    isCouponCodeValid,
    selectedAddons,
    setOrderCouponCodes,
    selectedCentersAndApps,
  ])

  // FULSAS-9564 — Auto-apply 4.0 Social Ads 75% off coupon
  useEffect(() => {
    if (selectedCentersAndApps) return // 5.0 flow — handled by use-auto-coupons.js

    const socialAdsInCart =
      selectedAddons?.filter(({planCode}) =>
        SOCIAL_ADS_4_CODES.includes(planCode),
      ) ?? []

    if (!socialAdsInCart.length) return

    // BUSREQ-13923: do not apply if client already has any Social Ads at any level
    const hasExisting4SA = accountInfo?.addOns?.some(({addOnCode}) =>
      SOCIAL_ADS_4_CODES.includes(addOnCode),
    )
    if (hasExisting4SA) return

    const isCouponAlreadyApplied = defaultCouponInfo?.some(
      c => c.code === '4_0_soc_ads_1stmo_75off',
    )

    if (isCouponAlreadyApplied) return

    async function applyAds4Coupon() {
      const {planCode} = socialAdsInCart[0]
      const url = `orders/coupon/validate?couponCode=4_0_soc_ads_1stmo_75off&country=${countryIsoValue}&planCode=${planCode}`
      const couponResponse = await client(url)
      if (couponResponse) {
        // Dispatch to autoCoupons so the discount calculation in this screen picks it up
        couponDispatch(setAutoCoupons([couponResponse]))
        // Also add to mergedCoupons so it gets sent to Recurly on purchase
        setOrderCouponCodes(prev =>
          removeDuplicatesFromArray([...prev, couponResponse], 'code'),
        )
        // Re-fetch the payment preview with the coupon so upgradePaymentPreview
        // reflects the discount in plan-comparison-details and cart-payment-details
        await getLegacyPaymentPreview?.(['4_0_soc_ads_1stmo_75off'])
      }
    }

    applyAds4Coupon()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedAddons, defaultCouponInfo])

  useEffect(() => {
    if (couponCode && couponCode.trim().length > 0) validateCoupon()
  }, [couponCode])

  const getUuid = clientInformation => {
    if (isNewOrder && !selectedCentersAndApps) {
      return clientInformation.uuid
    } else if (selectedCentersAndApps) {
      return clientInformation.paymentUuid
    } else {
      return clientInformation.randomId
    }
  }

  const handlePartnerOpsGenerateLink = async () => {
    async function fetchLinkExpiryTimeCountDetails() {
      if (roles.includes('PartnerOps')) {
        const response = await run(
          client(
            'keappartner/fetchConfigLookupValue/PartnerOpsLinkExpiryInMinutes',
          ),
        )
        if (response?.data.length) {
          setLinkExpiryInMinutes(Number(response.data[0].value) || 0)
        }
      }
    }
    async function generateKeapPartnerLink() {
      try {
        if (
          roles.includes('PartnerOps') &&
          selectedCentersAndApps &&
          selectedCentersAndApps !== undefined &&
          order5NUId // &&
          // typeof order5NUId === 'number'
        ) {
          // insert into keap partner link, cc_order tables
          let {centers, apps, oneTimes} = selectedCentersAndApps
          console.log('apps in generateKeapPartnerLink ' + JSON.stringify(apps))
          const thryvLeadsId = (
            centers.find(({name}) => name === 'Thryv Leads') ||
            apps.find(({name}) => name === 'Thryv Leads')
          )?.thryvLeadsId
          const seoProposal = centers.find(
            ({name}) => name.includes('SEO') && name !== 'AEO & SEO',
          )
          const sensisDomain = (
            findWebsiteEntitlement(centers) || apps.find(findWebsiteApp)
          )?.sensisSiteDomain
          const mcDomain = centers.find(
            ({name, code}) =>
              name.toLowerCase().includes('marketing') ||
              MC_2_0_PLANS.includes(code),
          )?.mcDomain
          const tlDomain = (
            centers.find(({code}) =>
              [
                'tl-mc-5-thryv-m2m',
                'tl-tax-5-thryv-m2m',
                'tl-5-thryv-m2m',
              ].includes(code),
            ) ||
            apps.find(({code}) =>
              [
                'tl-mc-5-thryv-m2m',
                'tl-tax-5-thryv-m2m',
                'tl-5-thryv-m2m',
              ].includes(code),
            )
          )?.tlDomain
          const keapDomain = centers.find(
            ({code, name}) =>
              KEAP_FAMILY_CODES.includes(code) ||
              name?.toLowerCase().includes('keap'),
          )?.keapDomain
          const parentSubscriptions = formatCenters(centers, ({code}) =>
            code.startsWith('cc_'),
          )
          const marketplace = apps.find(
            ({code}) => code === 'appmarket-5-thryv-m2m',
          )
          const isBCorMCInCart = centers.some(
            ({code}) => MC_PLANS.includes(code) || BC_PLANS.includes(code),
          )
          const alphaSeo =
            centers.find(({name}) => name === 'AEO & SEO') ||
            apps.find(({name}) => name === 'AEO & SEO')
          const plans = []
          let addOns = []
          let childSubscriptions = []
          for (const center of centers) {
            if (center?.code.startsWith('cc_')) {
              continue
            } else if (center?.code.startsWith('seobase-5-thryv-m2m')) {
              const formattedCenter = formatCenters(centers, ({name}) =>
                name.includes(center?.name),
              )
              addOns.push(formattedCenter[0])
            } else {
              const formattedCenter = formatCenters(centers, ({name}) =>
                name.includes(center?.name),
              )
              plans.push(formattedCenter[0])
            }
          }

          apps = apps.map(item => {
            const addOnItem = item
            if (addOnItem.code === 'appmarket-5-thryv-m2m' && alphaSeo) {
              addOnItem.addons = (addOnItem.addons || []).filter(
                ({code}) =>
                  ![
                    'seombg-5-thryv-m2m',
                    'seo-5-thryv-m2m',
                    'addon-5-leadslift-m2m',
                    'addon-5-leadslift-bni-m2m',
                  ].includes(code),
              )
            }
            return addOnItem
          })
          apps = apps.filter(
            ({code}) =>
              !['seombg-5-thryv-m2m', 'seo-5-thryv-m2m'].includes(code),
          )
          if (isNewTLMCAccessible) {
            const isTLLeadExist =
              centers.find(item => {
                return item.name === 'Thryv Leads'
              }) ||
              apps.find(item => {
                return item.name === 'Thryv Leads'
              })
            if (isTLLeadExist) {
              apps = apps.filter(({name}) => {
                return !name.includes('Growth Package')
              })
            }
          }
          const isBCUnlimitedInOrder = plans.some(
            ({code}) => code === 'bc_unlm-5-thryv-m2m',
          )
          // const appCatalogByCode = new Map(
          //   (all5PlanPrices?.apps || []).map(app => [app.code, app]),
          // )
          // const resolveKeapAddonWrapperCode = item => {
          //   if (String(item?.code || '').startsWith('addon-5-keap-addons')) {
          //     return item.code
          //   }
          //   if (
          //     String(item?.parentProduct || '').startsWith(
          //       'addon-5-keap-addons',
          //     )
          //   ) {
          //     return item.parentProduct
          //   }
          //   const catalogParent = appCatalogByCode.get(
          //     item?.code,
          //   )?.parentProduct
          //   if (String(catalogParent || '').startsWith('addon-5-keap-addons')) {
          //     return catalogParent
          //   }
          //   return null
          // }
          // const hasKeapFamilyCenterInOrder = centers.some(({code}) =>
          //   KEAP_FAMILY_CODES.includes(code),
          // )
          // const selectedKeapAddonParentCode =
          //   apps.map(resolveKeapAddonWrapperCode).find(Boolean) ||
          //   (hasKeapFamilyCenterInOrder
          //     ? centers.some(({code}) => String(code || '').includes('annual'))
          //       ? 'addon-5-keap-addons-annual'
          //       : 'addon-5-keap-addons'
          //     : undefined)
          // const thryvMaxAddons = all5PlanPrices.apps.find(
          //   ({code}) => code === selectedKeapAddonParentCode,
          // )
          // const thryvMaxAddonproducts = all5PlanPrices.apps
          //   .filter(app => app.parentProduct === selectedKeapAddonParentCode)
          //   .map(item => item.code)
          // const hasSelectedKeapChildAddon = apps.some(
          //   item =>
          //     resolveKeapAddonWrapperCode(item) ===
          //       selectedKeapAddonParentCode ||
          //     thryvMaxAddonproducts.includes(item.code),
          // )
          // const shouldAddKeapAddonsSubscription =
          //   Boolean(selectedKeapAddonParentCode) &&
          //   Boolean(thryvMaxAddons) &&
          //   (apps.some(({code}) => code === selectedKeapAddonParentCode) ||
          //     (hasKeapFamilyCenterInOrder && hasSelectedKeapChildAddon))
          // const hasKeapAddonsSubscription = addOns.some(
          //   ({code}) => code === thryvMaxAddons?.code,
          // )
          // if (shouldAddKeapAddonsSubscription && !hasKeapAddonsSubscription) {
          //   //Thryv Max Add Ons subscription
          //   addOns.push({
          //     code: thryvMaxAddons.code,
          //     quantity: 1,
          //     amount: 0,
          //     addons: apps
          //       .filter(
          //         item =>
          //           resolveKeapAddonWrapperCode(item) ===
          //             selectedKeapAddonParentCode ||
          //           thryvMaxAddonproducts.includes(item.code),
          //       )
          //       .map(item => {
          //         let quantity = item.quantity
          //         if (String(item.code).includes('addon-5-keap-textvoice')) {
          //           quantity = keapTextVoiceQty
          //         }
          //         if (String(item.code).includes('addon-5-keap-addcontacts')) {
          //           quantity = keapAddContactsQty
          //         }
          //         if (
          //           String(item.code).includes(
          //             'addon-5-keap-addcontacts-annual',
          //           )
          //         ) {
          //           quantity = keapAddContactsQtyAnnual
          //         }
          //         if (
          //           String(item.code).includes('addon-5-keap-textvoice-annual')
          //         ) {
          //           quantity = keapTextVoiceQtyAnnual
          //         }
          //         if (
          //           String(item.code).includes(
          //             'addon-5-keap-legacy-graphly-contacts-annual',
          //           )
          //         ) {
          //           quantity = keapAddContactsQtyGraphlyAnnual
          //         }
          //         if (
          //           String(item.code).includes(
          //             'addon-5-keap-legacy-plusthis-premium-trans-annual',
          //           )
          //         ) {
          //           quantity = plusThisPremiumQtyGraphlyAnnual
          //         }
          //         return {
          //           ...item,
          //           isAlreadyAdded:
          //             item.alreadyIncluded && item.alreadyIncluded === true
          //               ? true
          //               : false,
          //           quantity,
          //         }
          //       }),
          //   })
          // }

          // Add monthly keap addons either to legacy or new keap addons
          const thryvMaxAddonsMonthlyApp = apps.find(
            ({code}) =>
              code === 'addon-5-keap-addons' ||
              code === 'addon-5-keap-addons-legacy-m2m',
          )
          const thryvMaxAddonproducts = (all5PlanPrices?.apps || [])
            .filter(
              app =>
                (app.parentProduct === 'addon-5-keap-addons' ||
                  app.parentProduct === 'addon-5-keap-addons-legacy-m2m') &&
                app.code != 'addon-5-keap-addons' &&
                app.code != 'addon-5-keap-addons-legacy-m2m',
            )
            .map(item => item.code)

          if (thryvMaxAddonsMonthlyApp) {
            // Thryv Max Add Ons subscription
            const hasExplicitKeapAddContactsQty =
              keapAddContactsQty !== '' &&
              keapAddContactsQty !== null &&
              keapAddContactsQty !== undefined

            addOns.push({
              code: thryvMaxAddonsMonthlyApp.code,
              quantity: 1,
              addons: apps
                .filter(item => thryvMaxAddonproducts.includes(item.code))
                .map(({code, quantity = 1, alreadyIncluded}) => {
                  if (code === 'addon-5-keap-textvoice-m2m') {
                    quantity = keapTextVoiceQty
                  }
                  if (
                    code === 'addon-5-keap-addcontacts-m2m' &&
                    hasExplicitKeapAddContactsQty
                  ) {
                    quantity = keapAddContactsQty
                  }
                  return {
                    code,
                    quantity,
                    isAlreadyAdded: !!(
                      alreadyIncluded && alreadyIncluded === true
                    ),
                  }
                }),
            })
          }

          // Add annual keap addons either to legacy or new keap addons
          const thryvMaxAddonsAnnualApp = apps.find(
            ({code}) =>
              code === 'addon-5-keap-addons-annual' ||
              code === 'addon-5-keap-addons-legacy-annual',
          )
          const thryvMaxAddonproductsAnnual = all5PlanPrices.apps
            .filter(
              app =>
                (app.parentProduct === 'addon-5-keap-addons-annual' ||
                  app.parentProduct === 'addon-5-keap-addons-legacy-annual') &&
                app.code != 'addon-5-keap-addons-annual' &&
                app.code != 'addon-5-keap-addons-legacy-annual',
            )
            .map(item => item.code)

          if (thryvMaxAddonsAnnualApp) {
            addOns.push({
              code: thryvMaxAddonsAnnualApp.code,
              quantity: 1,
              addons: apps
                .filter(item => thryvMaxAddonproductsAnnual.includes(item.code))
                .map(({code, quantity = 1, alreadyIncluded}) => {
                  if (code === 'addon-5-keap-addcontacts-annual') {
                    quantity = keapAddContactsQtyAnnual
                  }
                  if (code === 'addon-5-keap-textvoice-annual') {
                    quantity = keapTextVoiceQtyAnnual
                  }
                  if (code === 'addon-5-keap-legacy-graphly-contacts-annual') {
                    quantity = keapAddContactsQtyGraphlyAnnual
                  }
                  if (
                    code === 'addon-5-keap-legacy-plusthis-premium-trans-annual'
                  ) {
                    quantity = plusThisPremiumQtyGraphlyAnnual
                  }
                  return {
                    code,
                    quantity,
                    isAlreadyAdded: !!(
                      alreadyIncluded && alreadyIncluded === true
                    ),
                  }
                }),
            })
          }

          addOns.push({
            code: marketplace.code,
            quantity: 1,
            amount: 0,
            addons: apps
              .filter(({name, code}) => {
                if (thryvMaxAddonproducts.includes(code)) return false
                // if (thryvMaxAddonproductsAnnual.includes(code)) return false
                if (
                  code === 'proservices-m2m' ||
                  code === 'tp_add-5-thryv-m2m'
                ) {
                  return false
                }
                if (code === 'addon-5-mktproeditor' && isBCUnlimitedInOrder) {
                  return false
                }
                if (
                  code === 'maxhvac-5-thryv-m2m' ||
                  code === 'maxroof-5-thryv-m2m' ||
                  code === 'maxelect-5-thryv-m2m' ||
                  code === 'maxplumb-5-thryv-m2m' ||
                  code === 'vert_mc_clientsvcs-5-thryv-m2m' ||
                  code === 'vert_mc_web_clientsvcs-5-thryv-m2m' ||
                  code === 'vert_clientsvcs-5-thryv-m2m' ||
                  code === 'vert_svcs-5-thryv-m2m' ||
                  code === 'appmarket-5-thryv-m2m' ||
                  code === 'vert_mc_clientsvcs-5-thryv-ot' ||
                  code === 'vert_mc_web_clientsvcs-5-thryv-ot' ||
                  code === 'vert_clientsvcs-5-thryv-ot' ||
                  code === 'addon-5-keap-addons' ||
                  code === 'addon-5-keap-addons-legacy-m2m' ||
                  code === 'addon-5-keap-addons-annual' ||
                  code === 'addon-5-keap-addons-legacy-annual' ||
                  code === 'tp_add-5-thryv-m2m' ||
                  code === '247support-m2m' ||
                  code === 'keap_max-sandbox-5-thryv-m2m'
                ) {
                  return false
                }
                const isListingsApp = code === 'app-listings'
                if (isListingsApp && isBCorMCInCart && frontendListingsBcMc) {
                  return false
                }
                return (
                  name !== 'AEO & SEO' &&
                  name !== 'SEO Keywords' &&
                  name !== 'AEO & SEO PowerBoost' &&
                  name !== 'SEO Non-Guaranteed' &&
                  name !== 'SEO Money Back Guarantee' &&
                  name !== 'Thryv Leads' &&
                  // name !== 'Keap Max' &&
                  name !== 'Leads Lift BNI' &&
                  name !== 'Leads Lift'
                )
              })
              .map(({code, quantity = 1, alreadyIncluded, amount}) => {
                return {
                  isAlreadyAdded: !!(
                    alreadyIncluded && alreadyIncluded === true
                  ),
                  code,
                  amount,
                  quantity,
                }
              }),
          })

          const keapMaxSandbox = apps.find(
            ({code}) => code === 'keap_max-sandbox-5-thryv-m2m',
          )
          if (keapMaxSandbox) {
            addOns.push({
              code: keapMaxSandbox.code,
              quantity: keapMaxSandbox.quantity || 1,
              isAlreadyAdded: !!(
                keapMaxSandbox.alreadyIncluded &&
                keapMaxSandbox.alreadyIncluded === true
              ),
              amount: keapMaxSandbox.amount,
              addons: [],
            })
          }

          const isLeadLiftExist = apps.find(
            item =>
              item.code === 'addon-5-leadslift-m2m' ||
              item.code === 'addon-5-leadslift-bni-m2m',
          )
          if (isLeadLiftExist) {
            addOns.push({
              code: isLeadLiftExist.code,
              quantity: isLeadLiftExist.quantity || 1,
              isAlreadyAdded: !!(
                isLeadLiftExist?.alreadyIncluded &&
                isLeadLiftExist?.alreadyIncluded === true
              ),
              amount: isLeadLiftExist.amount,
              addons: [],
            })
          }

          const oneTimeFees = oneTimes.map(
            ({code, quantity = 1, alreadyIncluded, amount, name}) => {
              return {
                code,
                name,
                quantity,
                amount,
                unitAmount: Number(amount) || 0,
                isAlreadyAdded: !!(alreadyIncluded && alreadyIncluded === true),
              }
            },
          )
          // Hanlde new Alpha SEO
          const newAlphaSEO = apps.find(({name}) => name === 'AEO & SEO')

          if (newAlphaSEO) {
            const keyword = apps.find(({name}) => name === 'SEO Keywords')
            const powerboost = apps.find(
              ({name}) => name === 'AEO & SEO PowerBoost',
            )

            const seoStartDate =
              newAlphaSEO.startDate ||
              newAlphaSEO.configuredOptions?.billingDate
            const seoSubscription = {
              code: newAlphaSEO.code,
              quantity: newAlphaSEO.amount || newAlphaSEO.quantity || 1,
              addons: [],
              ...(seoStartDate &&
                new Date(seoStartDate) >= new Date() && {
                  startDate: seoStartDate,
                }),
            }

            if (keyword) {
              seoSubscription.addons.push({
                code: keyword.code,
                quantity: keyword.quantity,
              })
            }

            if (powerboost) {
              seoSubscription.addons.push({
                code: powerboost.code,
                quantity: powerboost.quantity,
              })
            }

            addOns.push(seoSubscription)
          }
          if (newAlphaSEO) {
            for (const subscription of addOns) {
              if (
                subscription.code === 'seobase-5-thryv-m2m' &&
                subscription.quantity === 1
              ) {
                subscription.quantity = newAlphaSEO.amount
                subscription.amount = 1
              }
            }
          }

          // Check if any app is standalone to add it as a subscription
          for (const app of apps) {
            if (
              ((app?.name.includes('SEO Non-Guaranteed') ||
                app?.name.includes('SEO Money Back Guarantee')) &&
                !newAlphaSEO) ||
              app?.name === 'Thryv Leads' ||
              app?.code.startsWith('tl-')
              // app?.name === 'Keap Max'
            ) {
              const formattedApp = formatApps(apps, ({name}) =>
                name.includes(app?.name),
              )
              const tlStartDate =
                app.startDate || app.configuredOptions?.billingDate
              addOns.push({
                ...formattedApp[0],
                ...(tlStartDate &&
                  new Date(tlStartDate) >= new Date() && {
                    startDate: tlStartDate,
                  }),
              })
            } else if (app?.code === 'tp_add-5-thryv-m2m') {
              const formattedApp = formatApps(apps, ({name}) =>
                name.includes(app?.name),
              )
              addOns.push(formattedApp[0])
            } else if (app?.code === '247support-m2m') {
              const formattedApp = formatApps(apps, ({name}) =>
                name.includes(app?.name),
              )
              addOns.push(formattedApp[0])
            } else if (app?.code === 'proservices-m2m') {
              const formattedApp = formatApps(apps, ({name}) =>
                name.includes(app?.name),
              )
              addOns.push(formattedApp[0])
            } else if (
              app?.code === 'vert_mc_clientsvcs-5-thryv-m2m' ||
              app?.code === 'vert_mc_web_clientsvcs-5-thryv-m2m' ||
              app?.code === 'vert_clientsvcs-5-thryv-m2m' ||
              app?.code === 'vert_mc_clientsvcs-5-thryv-ot' ||
              app?.code === 'vert_mc_web_clientsvcs-5-thryv-ot' ||
              app?.code === 'vert_clientsvcs-5-thryv-ot' ||
              app?.code === 'vert_svcs-5-thryv-m2m'
              // app?.code === 'addon-5-keap-custdfy-ot'
            ) {
              const formattedApp = formatApps(
                apps,
                ({code}) => code === app?.code,
              )
              addOns.push(formattedApp[0])
            }
          }

          const isDesignFeeWaived = isWebsiteValid
            ? oneTimeFees.filter(oneTimeFee => oneTimeFee.code !== 'thryvdesg2')
            : oneTimeFees

          const hasZapier = addOns?.find(item =>
            item?.addons?.find(addOn => addOn.code === 'kp-zapier-750zaps-m2m'),
          )

          if (hasZapier) {
            addOns = addOns?.map(item => {
              if (
                item.addons?.find(
                  addOn => addOn.code === 'kp-zapier-750zaps-m2m',
                )
              ) {
                item.addons = item.addons?.filter(
                  addOn => addOn.code !== 'kp-zapier-750zaps-m2m',
                )
              }
              return item
            })
          }

          if (isAus) {
            const hasKCP = addOns?.find(
              item => item.code === 'keap_kcp-cert-5-fee',
            )

            if (hasKCP) {
              addOns = addOns?.map(item => {
                if (item.code === 'keap_kcp-cert-5-fee') {
                  const matchedQty = KCP_AU_QTY_MAPPING.find(
                    mapItem => Number(mapItem.amount) === Number(item.quantity),
                  )
                  return {
                    ...item,
                    quantity: matchedQty?.qty,
                  }
                } else return item
              })
            }
          }

          const KEAP_WRAPPER_CODES = new Set([
            'addon-5-keap-addons',
            'addon-5-keap-addons-annual',
            'addon-5-keap-addons-legacy-m2m',
            'addon-5-keap-addons-legacy-annual',
          ])
          const isKeapChildAddon = addon =>
            String(addon?.code || '').startsWith('addon-5-keap-') &&
            !KEAP_WRAPPER_CODES.has(addon?.code)

          const appmarketIndex = addOns.findIndex(
            item => item.code === 'appmarket-5-thryv-m2m',
          )
          const wrapperIndex = addOns.findIndex(item =>
            KEAP_WRAPPER_CODES.has(item.code),
          )

          if (appmarketIndex !== -1) {
            const appmarketItem = addOns[appmarketIndex]
            const movedKeapAddons = Array.isArray(appmarketItem.addons)
              ? appmarketItem.addons.filter(isKeapChildAddon)
              : []

            if (movedKeapAddons.length > 0) {
              addOns[appmarketIndex] = {
                ...appmarketItem,
                addons: (appmarketItem.addons || []).filter(
                  addon => !isKeapChildAddon(addon),
                ),
              }

              let wrapperItem =
                wrapperIndex !== -1 ? addOns[wrapperIndex] : null
              if (!wrapperItem) {
                wrapperItem = {
                  code: 'addon-5-keap-addons',
                  quantity: 1,
                  addons: [],
                }
                addOns.push(wrapperItem)
              }

              const existingCodes = new Set(
                (wrapperItem.addons || []).map(addon => addon.code),
              )
              wrapperItem.addons = [
                ...(wrapperItem.addons || []),
                ...movedKeapAddons.filter(
                  addon => !existingCodes.has(addon.code),
                ),
              ]
            }
          }

          childSubscriptions = [...plans, ...addOns, ...isDesignFeeWaived]
          const partnerLinkSubscriptions = [...plans, ...parentSubscriptions]
          // coupons
          const ALL_COUPON_CODES = orderCouponCodes
            .filter(coupon => {
              return coupon.isValid
            })
            .map(coupon => {
              return coupon.code
            })
          const partnerOpsXpCode =
            accountInfo?.xpCode ||
            accountInformation?.xpCode ||
            accountSubscriptionData?.accountInfo?.xpCode ||
            order?.xpCode ||
            order?.accountInformation?.xpCode ||
            order?.accountSubscriptionData?.accountInfo?.xpCode

          // Which toggle produced partnerOpsXpCode (keap-partner/legacy-partner) — same
          // fallback chain as above, so the backend can route it to the right Recurly
          // custom field (see utils/rep-attribution-matrix.js).
          const partnerOpsSalesRepOrPartner =
            accountInfo?.salesRepOrPartner ||
            accountInformation?.salesRepOrPartner ||
            accountSubscriptionData?.accountInfo?.salesRepOrPartner ||
            order?.salesRepOrPartner ||
            order?.accountInformation?.salesRepOrPartner ||
            order?.accountSubscriptionData?.accountInfo?.salesRepOrPartner

          const partnerLinkdata = {
            planCode: partnerLinkSubscriptions,
            addOnCode: addOns,
            oneTimeFees: isDesignFeeWaived,
            keapPartnerId: partnerOpsXpCode,
            partnerEmail: user?.email,
            countryCode: countryIsoValue,
          }

          // Only include orderHeaderId if it exists and is a valid number
          // if (order5NUId && typeof order5NUId === 'number') {
          if (order5NUId) {
            partnerLinkdata.orderHeaderId = order5NUId
          }
          const sendLinkData = {
            firstName: accountInfo.billingAddress
              ? accountInfo.recurlyFirst
              : accountInfo.firstName
              ? accountInfo.firstName
              : accountInformation.firstName,
            lastName: accountInfo.billingAddress
              ? accountInfo.recurlyLast
              : accountInfo.lastName
              ? accountInfo.lastName
              : accountInformation.lastName,
            email: accountInfo.billingAddress
              ? accountInfo.recurlyEmail
              : accountInfo.email
              ? accountInfo.email
              : accountInformation.email,
            company: accountInfo.billingAddress
              ? accountInfo.recurlyCompany
              : accountInfo.company
              ? accountInfo.company
              : accountInformation.company,
            currency:
              CC_CURRENCIES[
                COUNTRIES[
                  accountInfo.billingAddress
                    ? accountInfo.billingAddress.country
                    : accountInfo.country
                    ? accountInfo.country
                    : accountInformation.country
                ]?.value
              ],
            industryId: accountInfo.industry,
            businessAddress: {
              street: accountInfo.billingAddress
                ? accountInfo.billingAddress.street1
                : accountInfo.address
                ? accountInfo.address
                : accountInformation.address,
              city: accountInfo.billingAddress
                ? accountInfo.billingAddress.city
                : accountInfo.city
                ? accountInfo.city
                : accountInformation.city,
              state: accountInfo.billingAddress
                ? accountInfo.billingAddress.region ||
                  accountInfo.billingAddress.state
                : accountInfo.state
                ? accountInfo.state
                : accountInformation.state,
              postalCode: accountInfo.billingAddress
                ? accountInfo.billingAddress.postalCode ||
                  accountInfo.billingAddress.zipCode
                : accountInfo.postCode
                ? accountInfo.postCode
                : accountInformation.postCode,
              country: accountInfo.billingAddress
                ? accountInfo.billingAddress.country
                : accountInfo.country
                ? accountInfo.country
                : accountInformation.country,
              phone: accountInfo.billingAddress
                ? accountInfo.billingAddress.phone
                : accountInfo.companyPhone
                ? accountInfo.companyPhone
                : accountInformation.companyPhone,
            },
            contactPhone: accountInfo.billingAddress
              ? accountInfo.billingAddress.phone
              : accountInfo.companyPhone
              ? accountInfo.companyPhone
              : accountInformation.mobile,
            thryvId: order.CCAccountInfo.thryvId || accountInfo.thryvID,
            flow: 'upgrade',
            parentSubscriptions,
            childSubscriptions,
            // oneTimeFees: isDesignFeeWaived,
            // coupons: ccUpgradeCoupons || [],
            isCohort,
            keapAccount:
              keapAccount ||
              accountInfo?.keapAccount ||
              accountInformation?.keapAccount ||
              false,
            // keapId: keapID || '',
          }
          if (ALL_COUPON_CODES.length > 0) {
            partnerLinkdata.couponCode = ALL_COUPON_CODES
            sendLinkData.coupons = ALL_COUPON_CODES
          } else {
            partnerLinkdata.couponCode = []
            sendLinkData.coupons = []
          }
          if (cohortEaid) {
            sendLinkData.cohortEaid = cohortEaid
          }
          /*           if (accountInfo?.salesRepCode) {
            sendLinkData.behalfRepId = accountInfo.salesRepCode
            if (accountInfo.behalfFirst) {
              sendLinkData.behalfFirstName = accountInfo.behalfFirst
            }
            if (accountInfo.behalfLast) {
              sendLinkData.behalfLastName = accountInfo.behalfLast
            }
            if (accountInfo.behalfEmail) {
              sendLinkData.behalfEmail = accountInfo.behalfEmail
            }
          }
          if (accountInfo?.overrideRepCode) {
            sendLinkData.overrideRepId = accountInfo.overrideRepCode
            if (accountInfo.overrideRepFirst) {
              sendLinkData.overrideRepFirst = accountInfo.overrideRepFirst
            }
            if (accountInfo.overrideRepLast) {
              sendLinkData.overrideRepLast = accountInfo.overrideRepLast
            }
            if (accountInfo.overrideRepEmail) {
              sendLinkData.overrideRepEmail = accountInfo.overrideRepEmail
            }
          } */
          if (partnerOpsXpCode) {
            sendLinkData.xpCode = partnerOpsXpCode
          }
          if (partnerOpsSalesRepOrPartner) {
            sendLinkData.salesRepOrPartner = partnerOpsSalesRepOrPartner
          }
          if (
            ['AU', 'NZ'].includes(accountInfo.country) ||
            ['AU', 'NZ'].includes(accountInformation.country)
          ) {
            sendLinkData.abn = accountInfo.abn
              ? accountInfo.abn.replaceAll(' ', '')
              : accountInformation.abn.replaceAll(' ', '')
            if (!sendLinkData.abn.length) delete sendLinkData.abn
          }
          if (kickoffApptId) {
            sendLinkData.onboardingApptId = kickoffApptId
          }
          if (creativeApptId) {
            sendLinkData.creativeApptId = creativeApptId
          }
          if (thryvSuccessServicesApptId) {
            sendLinkData.thryvSuccessServicesApptId = thryvSuccessServicesApptId
          }
          if (thryvLeadsId) {
            sendLinkData.thryvLeadsId = thryvLeadsId
          }
          if (seoProposal) {
            sendLinkData.seoProposalId = seoProposal.seoProposalId
            sendLinkData.seoDomain = seoProposal.seoDomain
          }
          if (alphaSeo) {
            sendLinkData.seoProposalId = alphaSeo.alphaProposalId
            sendLinkData.seoDomain = alphaSeo.alphaDomain
            // data.seoCategories = alphaSeo.alphaCategories
            // data.seoGeos = alphaSeo.alphaGeos
          } else if (newAlphaSEO) {
            sendLinkData.seoProposalId = newAlphaSEO.alphaProposalId
            sendLinkData.seoDomain = newAlphaSEO.alphaDomain
          }
          if (sensisDomain) {
            sendLinkData.sensisDomain = sensisDomain
          }
          if (mcDomain) {
            sendLinkData.mcDomain = mcDomain
          }
          if (tlDomain) {
            sendLinkData.tlDomain = tlDomain
          }
          if (keapDomain) {
            sendLinkData.keapDomain = keapDomain
          }
          if (contactMethod === 'tss') {
            sendLinkData.tssUpgrade = true
          }
          if (selectedPaymentMethod) {
            sendLinkData.isInvoiceBilled = selectedPaymentMethod === 'Invoice'
          }
          if (allowInvoice && selectedPaymentMethod !== 'Invoice') {
            sendLinkData.updateToAutopay = true
          }
          if (keapTrailAppId && keapTrailAppId.length > 0) {
            sendLinkData.keapTrailId = keapTrailAppId
          }

          console.log('plans in payment details ' + JSON.stringify(plans))
          console.log('addons in payment details ' + JSON.stringify(addOns))
          const postData = {
            partnerLinkData: partnerLinkdata,
            orderData: sendLinkData,
          }
          const generateLink = await run(
            client('cc/order/partner-ops/generate-link', {
              data: postData,
            }),
          )
          // const deleteDuplicateLinks = await run(
          //   client('cc/order/partner-ops/deleteDuplicatePartnerLinks', {
          //     data: {
          //       keapPartnerId: partnerLinkdata?.keapPartnerId,
          //       orderHeaderId: partnerLinkdata?.orderHeaderId,
          //       partnerEmail: partnerLinkdata?.partnerEmail,
          //     },
          //     method: 'DELETE',
          //   }),
          // )
          // console.log('deleteDuplicateLinks ::', deleteDuplicateLinks)
          setPartnerOpsGeneratedUrl(generateLink?.generatedUrl)
        }
      } catch (error) {
        if (error.status !== 400) {
          toast.error(`Error generating link: ${error.message}`)
          throw error
        }
        if (error.errors) {
          error.errors.forEach(({message}) => toast.error(message))
        } else {
          toast.error(`Error generating link: ${error.message}`)
        }
      }
    }
    generateKeapPartnerLink()
    fetchLinkExpiryTimeCountDetails()
  }

  const handleSendLink = async data => {
    setProcessingMessage('Sending Link...')
    setProcessing(true)
    let clientInformation
    if (selectedCentersAndApps) {
      clientInformation = await sendCCPaymentLink(
        bypassSms ? 'tss' : contactMethod,
        accountInformation.mobile,
      )
    } else {
      const contactInfo =
        contactMethod === 'sms' ? data.smsContact : clientEmail
      clientInformation = await sendPaymentLink(contactMethod, contactInfo)
    }
    setProcessing(false)
    if (clientInformation) {
      const uuid = getUuid(clientInformation)
      setSendLinkError(false)
      setOrderId(clientInformation.orderId)
      updateTimeline(0, contactMethod)
      setShortenedUrl(clientInformation.shortenedUrl)
      if (bypassSms) {
        let data
        if (selectedCentersAndApps) {
          data = {
            orderUuid: uuid,
            billingMethod: 'TSS',
          }
        } else {
          data = {
            orderId: clientInformation.orderId.toString(),
            billingInfo: {
              firstName: accountInfo.recurlyFirst,
              lastName: accountInfo.recurlyLast,
              address: {
                street1: accountInfo.billingAddress.street1,
                city: accountInfo.billingAddress.city,
                state: accountInfo.billingAddress.region,
                country: accountInfo.billingAddress.country,
                postalCode: accountInfo.billingAddress.postalCode,
              },
            },
          }
        }
        try {
          await run(
            client(
              selectedCentersAndApps
                ? 'cc/order/save-billing'
                : 'orders/process/upgrade/billing-tss',
              {data, method: selectedCentersAndApps ? 'POST' : 'PUT'},
            ),
          )
          setOrderCompleted(true)
        } catch (err) {
          toast.error(err.message)
        }
      } else {
        setUuid(uuid)
        setIsLinkSent(true)
        setHideCouponInput(true)
      }
    } else {
      setSendLinkError(true)
      setShortenedUrl(null)
    }
  }
  const handleResendLink = async data => {
    resetTimeline()
    const resendInfo = {
      orderId,
      mobile: selectedCentersAndApps
        ? accountInformation.mobile
        : data.smsContact,
      method: contactMethod,
      email: clientEmail,
    }
    setProcessingMessage('Resending Link...')
    setProcessing(true)
    const {updatedUuid, shortenedUrl} =
      (await resendPaymentLink(resendInfo)) || {}
    setProcessing(false)
    if (updatedUuid) {
      setIsLinkSent(true)
      setSendLinkError(false)
      // 4.0 flow -> setUuid(updatedUuid.randomId || updatedUuid.uuid)
      setUuid(updatedUuid)
      updateTimeline(0, contactMethod)
      setShortenedUrl(shortenedUrl)
      setTimeout(() => {
        setShowEmailStatusLinkOption(true)
      }, 60000)
    } else {
      setSendLinkError(true)
      setShortenedUrl(null)
    }
  }
  const handleCheckSendGridData = async () => {
    setProcessingMessage('Checking Email Status...')
    setProcessing(true)

    const clientInfo = {
      email: clientEmail,
    }

    await checkClientEmailStatus(clientInfo)

    setProcessing(false)
  }
  const [timelineEvents, setTimelineEvents] = React.useState(autoPayTimeline)

  useEffect(() => {
    if (['AU', 'NZ'].includes(selectedCountry)) {
      setSelectedPaymentMethod('Invoice')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCountry])

  useEffect(() => {
    if (selectedPaymentMethod === 'Credit Card') {
      setTimelineEvents(autoPayTimeline)
    } else {
      setTimelineEvents(invoiceTimeline)
    }
  }, [selectedPaymentMethod])

  useEffect(() => {
    if (selectedCentersAndApps) return
    setMonthlyTotal(
      parseFloat(
        getTotalPrice(
          selectedAddons.filter(
            ({billingPreference}) =>
              billingPreference === BILLING_PREFERENCES[0],
          ),
        ),
      ),
    )

    setSemiAnnuallyTotal(
      parseFloat(
        getTotalPrice(
          selectedAddons.filter(
            ({billingPreference}) =>
              billingPreference === BILLING_PREFERENCES[1],
          ),
        ),
      ),
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedAddons])
  useEffect(() => {
    if (parseFloat(semiAnnuallyTotal) > 0) {
      setSemiAnnuallyBilling(true)
    }
    const nextSemiAnnualPayDay = new Date(
      new Date().getFullYear(),
      new Date().getMonth() + 6,
      new Date().getDate(),
    )
    const day = nextSemiAnnualPayDay.getDate()
    const month = nextSemiAnnualPayDay.toLocaleString('default', {
      month: 'long',
    })
    const year = nextSemiAnnualPayDay.getFullYear()
    setSemiAnnuallyPayDate(`${month},${day} ${year}`)
  }, [semiAnnuallyTotal])
  useEffect(() => {
    if (parseFloat(monthlyTotal) > 0) {
      setMonthlyBilling(true)
    }
    const nextMonthlyPayDay = new Date(
      new Date().getFullYear(),
      new Date().getMonth() + 1,
      new Date().getDate(),
    )
    const day = nextMonthlyPayDay.getDate()
    const month = nextMonthlyPayDay.toLocaleString('default', {month: 'long'})
    const year = nextMonthlyPayDay.getFullYear()
    setMonthlyPayDate(`${month} ${day}, ${year}`)
  }, [monthlyTotal])

  const updateTimeline = useCallback((step, contactMethod) => {
    setTimelineEvents(prevTimelineEvents => {
      const copyOfTimeline = prevTimelineEvents.map(event => ({...event}))
      // workaround added as step 2 n step 3 was happening simultaneously results in single hook call
      for (let i = 0; i <= step; i++) {
        if (copyOfTimeline[i].theme !== 'primary') {
          copyOfTimeline[i].eventSubtitle = dayjs().format('MMMM D [at] h:mm A')
          copyOfTimeline[i].theme = 'primary'
        }
      }

      const item = copyOfTimeline[1]
      copyOfTimeline[1] = {
        ...item,
        eventTitle: React.cloneElement(
          item.eventTitle,
          {},
          contactMethod === 'email'
            ? 'Client clicked link from email'
            : 'Client clicked link from phone number',
        ),
      }

      return copyOfTimeline
    })
    if (step === 3) {
      setOrderCompleted(true)
    }
  }, [])

  const resetTimeline = () => {
    setTimelineEvents(prevTimelineEvents => {
      const copyOfTimeline = prevTimelineEvents.map(event => ({...event}))
      copyOfTimeline.forEach(step => {
        step.eventSubtitle = ''
        step.theme = 'neutral'
      })
      return copyOfTimeline
    })
  }

  const processPurchase = async () => {
    if (!orderCompleted) return
    try {
      setProcessingMessage('Processing Purchase...')
      setProcessing(true)
      const processResponse = await client(
        isNewOrder
          ? 'orders/process/purchase-asynchronous'
          : 'orders/process/upgrade/purchase-asynchronous',
        {
          data: {
            orderId: orderId?.toString(),
            appUrl: window.location.origin,
          },
        },
      )
      // FULSAS-14529: appointment errors are silenced at the backend — filter them as a safety net
      const _apptSteps4 = ['onboarding', 'thryv success services']
      const _displayErrors4 = processResponse.errors
        ? processResponse.errors.filter(({step}) => !_apptSteps4.includes(step))
        : []
      if (_displayErrors4.length > 0) {
        _displayErrors4.forEach(({message}) => toast.error(message))
      } else {
        //captureCompleteOrder4()
      }
      setProcessing(false)
      nextStep()
    } catch (responseError) {
      setProcessing(false)
      if (responseError.status === 404) {
        toast.error(responseError.message)
        throw responseError
      }
      if (responseError.status !== 400) {
        toast.error(responseError.message)
        throw responseError
      }
      if (responseError.message) {
        toast.error(responseError.message)
      } else {
        responseError.errors.forEach(({message}) => toast.error(message))
      }
    }
  }

  const processPurchaseCC = async () => {
    if (!orderCompleted) return
    setProcessingMessage('Processing Purchase...')
    setProcessing(true)

    try {
      const processResponse = await client(
        'cc/order/process-purchase-asynchronous',
        {
          data: {
            orderId: order5NUId?.toString(),
            appUrl: window.location.origin,
          },
          bypass: 'clientSideAPI',
        },
      )

      let processErrorMsg = ''
      if (processResponse?.message) {
        processErrorMsg = processResponse.message
      } else if (
        processResponse?.errors &&
        Array.isArray(processResponse.errors)
      ) {
        // FULSAS-14529: appointment errors are silenced at the backend — filter them as a safety net
        const _apptStepsCC = ['onboarding', 'thryv success services']
        processErrorMsg = processResponse.errors
          .filter(({step}) => !_apptStepsCC.includes(step))
          .map(({message}) => message)
          .filter(Boolean)
          .join('\n')
      }

      if (processErrorMsg) {
        setProcessing(false)
        setProcessPurchaseErrorMessage(processErrorMsg)
        setShowProcessPurchaseErrorModal(true)
        toast.error(processErrorMsg)
        return
      }

      // Success - complete the order
      //captureCompleteOrder5()
      // if (order5NUId) {
      //   try {
      //     await run(
      //       client('ordercapture/services/updateOrderStatus', {
      //         data: {order_id: order5NUId, order_status: 'Completed'},
      //         method: 'PUT',
      //       }),
      //     )
      //   } catch (err) {
      //     console.error(
      //       'updateOrderStatus failed (order already completed):',
      //       err,
      //     )
      //   }
      // }
      setProcessing(false)
      navigate('/success', {
        state: {
          email: clientEmail,
          flow: isNewOrder ? 'new order' : 'upgrade',
          onboardingCallDate,
          creativeCallDate,
          thryvSuccessServicesCallDate,
          isCC: true,
          isSEOIncluded,
          softwareUpgraded,
        },
      })
    } catch (error) {
      setProcessing(false)
      let errorMsg = ''

      console.error('processPurchaseCC error:', error)

      if (error.message === 'Failed to fetch') {
        errorMsg =
          "We couldn't confirm the response from your browser. This is usually caused by a momentary issue with your internet connection (like a VPN, proxy, or weak Wi-Fi).\n\nIf the new subscriptions are already showing in Recurly or in the account, the purchase probably went through. Please don't try the payment again until someone double-checks the order in OOE or Recurly.\n\nIf nothing has appeared yet, you can refresh the page and try again when you have a stable connection."
      } else if (error.message) {
        errorMsg = error.message
      } else if (error.errors && Array.isArray(error.errors)) {
        errorMsg = error.errors.map(({message}) => message).join('\n')
      } else if (error.toString) {
        errorMsg = error.toString()
      } else {
        errorMsg = 'An unexpected error occurred while processing the purchase'
      }

      if (errorMsg) {
        setProcessPurchaseErrorMessage(errorMsg)
        setShowProcessPurchaseErrorModal(true)
        if (error.message !== 'Failed to fetch') {
          toast.error(errorMsg)
        }
      }
    }
  }

  // const captureCompleteOrder5 = async () => {
  //   const fetchAccountSubscriptions = async (retriesAmount = 3) => {
  //     try {
  //       const url = `accounts/5/subscriptions?thryvId=${orderData5CU.order.CCAccountInfo.thryvId}`
  //       const response = await client(url)
  //       if (
  //         !response.childSubscriptions.find(
  //           sub => sub.code === 'appmarket-5-thryv-m2m',
  //         ) ||
  //         !response.parentSubscriptions.find(sub => sub.code.includes('cc_'))
  //       ) {
  //         throw Error('missing subscription')
  //       } else {
  //         getOrder5AndComplete(response)
  //       }
  //     } catch (err) {
  //       if (
  //         [404, 500].includes(err.status) ||
  //         err.message === 'missing subscription'
  //       ) {
  //         if (retriesAmount === 0) throw err
  //         setTimeout(() => fetchAccountSubscriptions(retriesAmount - 1), 1000)
  //       }
  //     }
  //   }
  //   fetchAccountSubscriptions()
  // }

  // const captureCompleteOrder4 = async () => {
  //   const fetchAccountSubscriptions = async () => {
  //     try {
  //       const url = `subscription/uuid-${orderData4CU.order.billingAccountId}`
  //       const response = await client(url)
  //       if (response.thryvID) {
  //         getOrder5AndComplete(response)
  //       }
  //     } catch (err) {
  //       if (err.status === 404) {
  //         console.log(err)
  //       }
  //       if (err.status !== 404) {
  //         console.log(err)
  //       }
  //     }
  //   }
  //   fetchAccountSubscriptions()
  // }

  // const getOrder5AndComplete = async subscriptions => {
  //   try {
  //     console.log('getOrder5AndComplete - subscriptions', subscriptions)
  //     let subscriptionLines = []
  //     if (isUpgrade || isNewOrder) {
  //       if (isNewOrder || isCCPlan) {
  //         if (
  //           subscriptions &&
  //           subscriptions.parentSubscriptions &&
  //           subscriptions.childSubscriptions
  //         ) {
  //           subscriptionLines = [
  //             ...subscriptions.parentSubscriptions,
  //             ...subscriptions.childSubscriptions,
  //           ]
  //         }
  //       } else {
  //         if (subscriptions && subscriptions.addOns) {
  //           subscriptionLines = [...subscriptions.addOns]
  //         }
  //       }
  //     }
  //     const url = `ordercapture/services/getOrderDetails/${order5NUId}`
  //     const response = await client(url)
  //     if (response.success) {
  //       console.log('get order header lines and discounts', response)
  //       console.log('get subscriptionLines', subscriptionLines)
  //       const order5Data = response.response
  //       if (order5Data) {
  //         order5Data.lines?.forEach(oLine => {
  //           subscriptionLines.forEach(subLine => {
  //             if (
  //               (subLine?.code && subLine?.code === oLine.saas_product_code) ||
  //               (subLine?.addOnCode &&
  //                 subLine?.addOnCode === oLine.saas_product_code)
  //             ) {
  //               oLine.recurly_subscription_id = subLine?.uuid
  //                 ? subLine?.uuid
  //                 : ''
  //               // oLine.saas_instance_id = subLine?.id ? subLine?.id : ''
  //             } else {
  //               if (subLine && subLine.addons && subLine.addons.length > 0) {
  //                 const addonLine = subLine.addons.find(
  //                   line =>
  //                     (line?.code && line?.code === oLine.saas_product_code) ||
  //                     (line?.addOnCode &&
  //                       line?.addOnCode === oLine.saas_product_code),
  //                 )
  //                 console.log('addonLine', addonLine)
  //                 if (addonLine) {
  //                   oLine.recurly_subscription_id = addonLine?.uuid
  //                     ? addonLine?.uuid
  //                     : addonLine?.subscriptionId
  //                     ? addonLine?.subscriptionId
  //                     : null
  //                   // oLine.saas_instance_id = addonLine?.id ? addonLine?.id : ''
  //                 }
  //               }
  //             }
  //           })
  //           oLine.order_line_status = 'Completed'
  //         })
  //         order5Data.order_status = 'Completed'
  //         order5Data.order_completed_date = new Date()
  //         order5Data.order_version =
  //           order5Data.order_version === 5 ? '5.0' : '4.0'
  //         completeOrder5(order5Data)
  //       }
  //     }
  //     console.log('get order - ', response)
  //   } catch (error) {
  //     if (error.status !== 400) {
  //       console.log(`Error complete order: ${error.message}`)
  //     }
  //     if (error.errors) {
  //       // error.errors.forEach(({message}) => toast.error(message))
  //       error.errors.forEach(({message}) => console.log(message))
  //     } else {
  //       console.log(`Error complete order: ${error.message}`)
  //     }
  //   }
  // }

  // const completeOrder5 = async order5Data => {
  //   try {
  //     console.log('order complete Data - new-upgrade', order5Data)
  //     order5Data.keap_account = keapAccount || false
  //     const result = await run(
  //       client('ordercapture/services/updateOrder', {
  //         data: order5Data,
  //         method: 'POST',
  //       }),
  //     )
  //     console.log('order Completed - new-upgrade', result)
  //   } catch (error) {
  //     if (error.status !== 400) {
  //       console.log(
  //         `Error complete order - captureCompleteOrder5: ${error.message}`,
  //       )
  //     }
  //     if (error.errors) {
  //       // error.errors.forEach(({message}) => toast.error(message))
  //       error.errors.forEach(({message}) => console.log(message))
  //     } else {
  //       console.log(
  //         `Error complete order - captureCompleteOrder5: ${error.message}`,
  //       )
  //     }
  //   }
  // }

  useEffect(() => {
    const socket = io(REACT_APP_OOE_SERVICE_URL, {
      transports: ['websocket'],
    })
    socket.on('connect', () => {})
    if (uuid) {
      socket.emit('join', {uuid}, () => {})
      socket.on('stepTaken', ({stepNumber}) => {
        updateTimeline(stepNumber, contactMethod)
      })
      socket.on('error-message', ({message}) => {
        toast.error(message)
      })
    }
    return () => {
      socket.close()
    }
  }, [uuid, updateTimeline])

  useEffect(() => {
    window.addEventListener('popstate', function (event) {
      setIsHeaderVisible(true)
    })
    setIsHeaderVisible(false)
    return () => {
      window.removeEventListener('popstate', function (event) {
        setIsHeaderVisible(true)
      })
    }
  }, [setIsHeaderVisible])

  useEffect(() => {
    if (!selectedCentersAndApps) return
    let {apps, centers} = selectedCentersAndApps

    const calcTotal = ({arr, discountAmount}) => {
      return arr.reduce((acc, {name, amount, quantity, code, unitAmount}) => {
        quantity =
          name === 'Thryv Leads' ||
          (name.includes('SEO') &&
            name !== 'AEO & SEO' &&
            name !== 'SEO Keywords' &&
            name !== 'AEO & SEO PowerBoost')
            ? 1
            : quantity

        let price =
          code === 'addon-5-leadslift-m2m' ? amount : amount * quantity

        // const transitionApplies = (
        //   isNewOrder ? CC_PLANS : eligibleTransitionCenters
        // ).some(plan => name.toLowerCase().includes(plan))

        if (upgradePaymentPreview) {
          const previewAmount = getPreviewItemTotal({
            upgradePaymentPreview,
            item: {name, price},
            country: countryIsoValue,
          })
          if (previewAmount) price = previewAmount
        }

        if (!price) return acc

        // if (
        //   transitionApplies &&
        //   discountAmount &&
        //   discountType === 'New Client Transition'
        // ) {
        //   price = price - price * (discountAmount / 100)
        // }
        if (discountAmount) {
          price = price - price * (discountAmount / 100)
        }

        if (
          ccCouponInfo?.appliesToPlans?.includes(code) &&
          ccCouponInfo?.duration === 'forever'
        ) {
          const discountAmount = ccCouponInfo?.discountAmount
          if (discountAmount && price < discountAmount) {
            price -= ccCouponInfo.discountAmount
          }
        }

        return acc + price
      }, 0)
    }
    const isTLInCenters =
      centers.find(
        ({code, thryvLeadsId}) => code.includes('tl-mc') && thryvLeadsId,
      ) ||
      apps.find(
        ({code, thryvLeadsId}) => code.includes('tl-mc') && thryvLeadsId,
      )
    const isBCorMCInCart =
      selectedCentersAndApps?.centers.some(
        ({code}) => BC_PLANS.includes(code) || MC_PLANS.includes(code),
      ) || false
    apps = apps.filter(({code, name}) => {
      if (code === 'app-listings' && isBCorMCInCart) {
        return false
      }
      if (name.toLowerCase().includes('growth package')) {
        return !isTLInCenters
      }
      if (['seombg-5-thryv-m2m', 'seo-5-thryv-m2m'].includes(code)) {
        const isNewSEOExist = selectedCentersAndApps.centers.find(
          ({code}) => code === 'seobase-5-thryv-m2m',
        )
        if (isNewSEOExist) {
          return false
        }
        return true
      }
      return true
    })
    const appsTotal = calcTotal({arr: apps})
    const centersTotal = calcTotal({arr: centers})
    const nextMonthAmount = calcTotal({
      arr: centers,
      discountAmount: 0,
    })

    setCcTotal(centersTotal + appsTotal)
    setNextAmountDue(nextMonthAmount + appsTotal)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    autoCouponInfo,
    ccCouponInfo,
    selectedCentersAndApps,
    setOrderCouponCodes,
    isNewOrder,
    stringifiedEligibleTransitionCenters,
    upgradePaymentPreview,
  ])

  useEffect(() => {
    function haveNewEntitlementsBeenAdded(selectedCenter, defaultCenter) {
      if (!selectedCenter || selectedCenter.entitlements.length === 0) {
        return false
      }
      if (
        (!defaultCenter || defaultCenter.entitlements.length === 0) &&
        selectedCenter.entitlements.length > 0
      ) {
        return true
      }
      if (defaultCenter && defaultCenter.entitlements.length > 0) {
        return selectedCenter.entitlements.some(
          selectedEntitlement =>
            !defaultCenter.entitlements.some(
              defaultEntitlement =>
                defaultEntitlement.name === selectedEntitlement.name,
            ),
        )
      }
      return false
    }
    if (!isNewOrder && selectedCentersAndApps?.centers.length > 1) {
      const defaultBusinessCenter = defaultCentersAndApps.centers.find(
        ({name}) => name.includes('Business'),
      )
      const selectedBusinessCenter = selectedCentersAndApps.centers.find(
        ({name}) => name.includes('Business'),
      )
      const defaultMarketingCenterPro = defaultCentersAndApps.centers.find(
        ({name}) => name === 'Marketing Center Pro',
      )
      const selectedMarketingCenterPro = selectedCentersAndApps.centers.find(
        ({name}) => name === 'Marketing Center Pro',
      )
      const centersUpgraded = selectedCentersAndApps.centers.some(
        ({name, alreadyIncluded}) =>
          (name.includes('Marketing') || name.includes('Business')) &&
          !alreadyIncluded,
      )
      if (
        haveNewEntitlementsBeenAdded(
          selectedBusinessCenter,
          defaultBusinessCenter,
        ) ||
        haveNewEntitlementsBeenAdded(
          selectedMarketingCenterPro,
          defaultMarketingCenterPro,
        ) ||
        centersUpgraded
      ) {
        setSoftwareUpgraded(true)
      }
    }
  }, [
    isNewOrder,
    defaultCentersAndApps?.centers,
    selectedCentersAndApps?.centers,
  ])

  useEffect(() => {
    if (!frontendSideNav) return

    const elem = document.getElementById('app-container')

    elem.style.gridTemplateAreas =
      '"main-content main-content" "main-content main-content" "sidebar footer"'
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleRemoveCoupon = async e => {
    console.log('Coupon removed is :: ', e)
    console.log(couponInfo.filter(coupon => coupon.code != e))
    const couponsAfterRemoving = couponInfo.filter(coupon => coupon.code != e)
    setCouponInfo(couponsAfterRemoving)
  }

  // Check if any coupons/discounts are applied to the order
  // This prevents bypassing payment link for ratable items made free via coupon
  const hasAppliedCoupons =
    orderCouponCodes &&
    orderCouponCodes.length > 0 &&
    orderCouponCodes.some(coupon => coupon.isValid)

  useEffect(() => {
    if (!isLinkSent) return
  }, [])

  const handleExitOrder = () => {
    navigate('/accounts/my-accounts')

    if (frontendSideNav) {
      const elem = document.getElementById('app-container')
      elem.style.gridTemplateAreas =
        '"header header" "sidebar main-content" "sidebar footer"'
    }

    if (!isHeaderVisible) {
      setIsHeaderVisible(true)
    }
  }

  return (
    <>
      <NewOrderLayout
        title="Payment Details"
        cancelOrder
        cancelUrl="/accounts/my-accounts"
        isPaymentDetailsPage
        handleExitOrder={handleExitOrder}
        prevStep={prevStep}
        showContinueButton={!roles.includes('PartnerOps')}
        disableNextButton={!orderCompleted}
        cohortEaid={cohortEaid}
        order5NUId={order5NUId}
        isCancelOrder5={isCancelOrder5}
        cancelOrder5={cancelOrder5}
        isBillingNoticeDisplayed={isBillingNoticeDisplayed}
        setIsBillingNoticeDisplayed={setIsBillingNoticeDisplayed}
        isLinkSent={isLinkSent}
        nextStep={async () => {
          if (cohortEaid) {
            try {
              await run(
                client(`cc/order/updateaccountattribute/${cohortEaid}`, {
                  method: 'GET',
                }),
              )
            } catch (err) {
              console.log(err)
            }
          }
          if (!selectedCentersAndApps) {
            processPurchase()
          } else {
            processPurchaseCC()
          }
          if (frontendSideNav) {
            const elem = document.getElementById('app-container')
            elem.style.gridTemplateAreas =
              '"header header" "sidebar main-content" "sidebar footer"'
          }
          if (!isHeaderVisible) {
            setIsHeaderVisible(true)
          }
        }}
        style={processing && {opacity: '0.4', pointerEvents: 'none'}}
      >
        {allowInvoice && frontendCohortRelease && showBillingModal && (
          <BillingOptionsModal
            setSelectedPaymentMethod={method => {
              setSelectedPaymentMethod(method)
              setShowBillingModal(false)
            }}
            selectedPaymentMethod={selectedPaymentMethod}
          />
        )}
        {selectedCentersAndApps && (
          <div>
            <AccountInfoBanner
              thryvId={accountInfo?.thryvID || accountInformation?.thryvId}
              companyName={
                accountInfo?.recurlyCompany || accountInformation?.company
              }
              firstName={
                accountInfo?.recurlyFirst || accountInformation?.firstName
              }
              lastName={
                accountInfo?.recurlyLast || accountInformation?.lastName
              }
              billTo={accountInfo?.billTo || accountInformation?.billTo}
              style={{marginLeft: '20px', marginTop: '20px'}}
            />
            <CcSidebar
              selectedCentersAndApps={selectedCentersAndApps}
              country={countryIsoValue}
              eligibleTransitionCenters={eligibleTransitionCenters}
              defaultCentersAndApps={defaultCentersAndApps}
              setCurrentPrice={setCurrentPrice}
              setTotalCcPrice={setTotalCcPrice}
              previewRequestFinished={previewRequestFinished}
              isCohort={isCohort}
              accountInfo={accountInfo}
              isWebsiteValid={isWebsiteValid}
              isNewTLMCAccessible={isNewTLMCAccessible}
            />
          </div>
        )}
        {processing && (
          <div
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              color: 'black',
              fontWeight: '600',
              zIndex: '3',
            }}
          >
            <Spinner />
            <span style={{fontSize: '24px'}}>{processingMessage}</span>
          </div>
        )}
        {!selectedCentersAndApps && (
          <div>
            <AccountInfoBanner
              thryvId={accountInfo?.thryvID || accountInformation?.thryvId}
              companyName={
                accountInfo?.recurlyCompany || accountInformation?.company
              }
              firstName={
                accountInfo?.recurlyFirst || accountInformation?.firstName
              }
              lastName={
                accountInfo?.recurlyLast || accountInformation?.lastName
              }
              billTo={accountInfo?.billTo || accountInformation?.billTo}
              style={{marginLeft: '20px', marginTop: '20px'}}
            />
            <div style={{paddingLeft: '5px'}}>
              {!isNewOrder && !isCCPlan && (
                <PlanComparisonDetails
                  accountInfo={accountInfo}
                  selectedPlan={selectedPlan}
                  listOfSelectedAddons={selectedAddons}
                  discount={discountAmount + autoCouponDiscount}
                  setCurrentPrice={setCurrentPrice}
                />
              )}
            </div>
            {!isNewOrder && <hr style={{maxWidth: '380px'}} />}
            <CartPaymentDetails
              listOfAddons={selectedAddons}
              totalDiscount={discountAmount + autoCouponDiscount}
              cartProducts={cartProducts}
              setCartProducts={setCartProducts}
              selectedCountry={selectedCountry}
              currentStep={currentStep}
              monthlyBilling={monthlyBilling}
              semiAnnuallyBilling={semiAnnuallyBilling}
              currentPlanName={accountInfo?.planName}
              isNewOrder={isNewOrder}
              accountInfo={accountInfo}
              upgradeAccountInfo={accountInfo}
            />
          </div>
        )}
        <div
          className={selectedCentersAndApps ? 'pl-4 pr-4 pb-4 mt-4' : 'p-4'}
          style={
            selectedCentersAndApps
              ? {
                  borderLeft: '1px solid #CCCCCC',
                  minHeight: '628px',
                  gridColumnStart: 2,
                  position: 'relative',
                  marginLeft: '40px',
                }
              : {}
          }
        >
          {(isNewOrder || isUpgrade) &&
            (kickoffApptId || creativeApptId || thryvSuccessServicesApptId) && (
              <CountdownTimer
                countdownTimeMS={
                  new Date().getTime() + (linkExpiryInMinutes * 60000 + 1000)
                }
                isHourlyNeeded={linkExpiryInMinutes > 60}
                creativeApptId={creativeApptId}
                thryvSuccessServicesApptId={thryvSuccessServicesApptId}
                kickoffApptId={kickoffApptId}
                setCreativeApptId={setCreativeApptId}
                setKickoffApptId={setKickoffApptId}
                setThryvSuccessServicesApptId={setThryvSuccessServicesApptId}
                countryIsoValue={countryIsoValue}
                prevStep={prevStep}
                setCreativeCallDate={setCreativeCallDate}
                setOnboardingCallDate={setOnboardingCallDate}
                setThryvSuccessServicesCallDate={
                  setThryvSuccessServicesCallDate
                }
                frontendCcPaymentDetails={selectedCentersAndApps}
                updateApptOnExpire={updateApptOnExpire}
                onExpire={() => setIsAppointmentExpired(true)}
              />
            )}
          {!hideCouponInput && !selectedCentersAndApps && (
            <>
              <CouponContainer>
                {/* <Input
                  className="w-100"
                  type="text"
                  placeholder="Coupon or Promotional Code"
                  aria-label="Coupon or Promotional Code"
                  name="couponCode"
                  withLabel
                  labelType="floating"
                  variant="default"
                  value={couponCode}
                  onChange={handleCouponCodeChange}
                /> */}

                {!(couponInfo.length >= maxAllowedCoupons) ? (
                  <>
                    <AsyncSelect
                      cacheOptions
                      placeholder="Enter a Coupon"
                      dsiable
                      loadOptions={loadOptions}
                      onChange={handleCouponCodeChange}
                      value={couponCode}
                      theme={theme => ({
                        ...theme,
                        borderRadius: 0,
                        colors: {
                          ...theme.colors,
                          primary25: 'silver',
                          primary: 'black',
                        },
                      })}
                    />
                  </>
                ) : null}

                {isCouponCodeValid && (
                  <Icon
                    style={{cursor: 'pointer'}}
                    className="ml-3"
                    type="solid"
                    variant="circleCheck"
                    color="#5cb85c"
                    height="30"
                    width="30"
                  />
                )}
                {/* <Button
                  variant="primary"
                  type="button"
                  onClick={validateCoupon}
                  disabled={
                    couponInfo.length >= maxAllowedCoupons ? true : false
                  }
                >
                  Apply
                </Button> */}
              </CouponContainer>
              {couponInfo && couponInfo.length > 0
                ? couponInfo.map(coupon => {
                    return (
                      <div
                        key={coupon.code + '_div'}
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'left',
                        }}
                      >
                        <span
                          style={{
                            // flex: 1,
                            // alignText: 'left',
                            marginRight: '5px',
                          }}
                          key={coupon.code}
                        >
                          {coupon.description}
                        </span>
                        <button
                          style={{
                            width: '100px',
                          }}
                          onClick={() => handleRemoveCoupon(coupon.code)}
                        >
                          <Icon
                            type="regular"
                            variant="x"
                            height="15"
                            width="15"
                            color="#FF6100"
                          />
                        </button>
                      </div>
                    )
                  })
                : null}
            </>
          )}

          <div
            className={`d-flex mb-5 ${
              (kickoffApptId || creativeApptId || thryvSuccessServicesApptId) &&
              selectedCentersAndApps &&
              'mt-3'
            } ${selectedCentersAndApps ? 'justify-content-between' : 'mt-4'}`}
          >
            <PaymentLink
              contactMethod={contactMethod}
              setContactMethod={setContactMethod}
              mobile={accountInformation.mobile}
              email={clientEmail}
              currentPrice={currentPrice}
              totalCcPrice={totalCcPrice}
              totalPrice={totalPrice}
              bypassSms={bypassSms}
              hasAppliedCoupons={hasAppliedCoupons}
              showEmailStatusLinkOption={showEmailStatusLinkOption}
              setBypassSms={setBypassSms}
              isLinkSent={isLinkSent}
              handlePartnerOpsGenerateLink={handlePartnerOpsGenerateLink}
              handleSendLink={
                selectedCentersAndApps
                  ? handleSendLink
                  : handleSubmit(handleSendLink)
              }
              handleResendLink={
                selectedCentersAndApps
                  ? handleResendLink
                  : handleSubmit(handleResendLink)
              }
              handleCheckSendGridData={handleCheckSendGridData}
              showSmsOption={showSmsOption}
              setShwoSmsOption={setShwoSmsOption}
              sendLinkError={sendLinkError}
              shortenedUrl={shortenedUrl}
              is5Order={!!selectedCentersAndApps}
              partnerOpsGeneratedUrl={partnerOpsGeneratedUrl}
              isAppointmentExpired={isAppointmentExpired}
            >
              {selectedCentersAndApps ? (
                <ParagraphText variant="lg" className="font-weight-bold">
                  Payment Link
                </ParagraphText>
              ) : (
                <SendPaymentLinkText
                  variant="lg"
                  className="font-weight-bold mt-5"
                >
                  Send Payment Link
                </SendPaymentLinkText>
              )}
            </PaymentLink>
            {(hideCouponInput || (selectedCentersAndApps && isLinkSent)) &&
              !bypassSms && (
                <TimelineContainer
                  frontendCcPaymentDetails={selectedCentersAndApps}
                >
                  <Timeline variant="small" events={timelineEvents} />
                </TimelineContainer>
              )}
          </div>
          {!selectedCentersAndApps && (
            <>
              {isNewOrder && monthlyBilling && transitionOrder ? (
                <>
                  <TransitionContainer>
                    <h3 style={{textAlign: 'center'}}>
                      <strong>Monthly Overview</strong>
                    </h3>
                    <p>Transition Incentive</p>
                    <li>
                      <ParagraphText variant="reg">
                        <strong>Month 1 </strong> (Transition Incentive: 75%)
                      </ParagraphText>
                      <ParagraphText variant="reg">
                        <strong>
                          {formatPrice(
                            Math.max(
                              monthlyPrice - incentiveEligibleCart * 0.75,
                              0,
                            ),
                            1,
                            '',
                            countryIsoValue,
                          )}{' '}
                          {!isAus && !upgradePaymentPreview?.tax && '+ Tax'}
                        </strong>
                      </ParagraphText>
                    </li>
                    <li>
                      <ParagraphText variant="reg">
                        <strong>Month 2 </strong>(Transition Incentive: 50%)
                      </ParagraphText>
                      <ParagraphText variant="reg">
                        <strong>
                          $
                          {Math.max(
                            monthlyPrice - incentiveEligibleCart * 0.5,
                            0,
                          ).toFixed(2)}{' '}
                          {!isAus && !upgradePaymentPreview?.tax && '+ Tax'}
                        </strong>
                      </ParagraphText>
                    </li>
                    <li className="child">
                      <ParagraphText variant="reg">
                        <strong>Month 3 </strong>(Transition Incentive: 25%)
                      </ParagraphText>
                      <ParagraphText variant="reg">
                        <strong>
                          {Math.max(
                            monthlyPrice - incentiveEligibleCart * 0.25,
                            0,
                          )}{' '}
                          {!isAus && !upgradePaymentPreview?.tax && '+ Tax'}
                        </strong>
                      </ParagraphText>
                    </li>
                    <li className="child">
                      {' '}
                      <ParagraphText variant="reg">
                        <strong>Month 4+</strong>
                      </ParagraphText>
                      <ParagraphText variant="reg">
                        <strong>
                          {Math.max(monthlyPrice, 0)}{' '}
                          {!isAus && !upgradePaymentPreview?.tax && '+ Tax'}
                        </strong>
                      </ParagraphText>
                    </li>
                    <li className="child">
                      {' '}
                      <ParagraphText variant="reg">
                        <strong>Due Today</strong>
                      </ParagraphText>
                      <ParagraphText variant="reg">
                        <strong>
                          {formatPrice(
                            Math.max(totalPrice, 0),
                            1,
                            '',
                            countryIsoValue,
                          )}
                        </strong>
                        {!isAus &&
                          !upgradePaymentPreview?.tax &&
                          '(est. tax to be calculated)'}
                      </ParagraphText>
                    </li>
                  </TransitionContainer>
                </>
              ) : (
                <div className="d-flex justify-content-between pb-0 pr-4 pl-4 pt-2 m-0 mt-4">
                  <div className="d-flex flex-column">
                    <ParagraphText variant="lg" className="font-weight-bold">
                      {isNewOrder
                        ? 'Total Due Today'
                        : 'New Recurring Subscription Total'}
                    </ParagraphText>
                    {!isNewOrder && (
                      <ParagraphText
                        variant="reg"
                        color="thryv-gray-medium-500"
                        style={{maxWidth: '360px'}}
                      >
                        *For existing subscriptions, today&apos;s charges will
                        only include the prorated amount of the additional
                        services purchased until the next billing cycle.
                      </ParagraphText>
                    )}
                  </div>
                  <div className="text-right">
                    <ParagraphText variant="reg" className="font-weight-bold">
                      {formatPrice(
                        Math.max(totalPrice, 0),
                        1,
                        '',
                        countryIsoValue,
                      )}
                    </ParagraphText>
                    {!isAus && (
                      <ParagraphText variant="reg" className="font-weight-bold">
                        {isNewOrder
                          ? '(est. tax to be calculated)'
                          : 'Plus applicable tax'}
                      </ParagraphText>
                    )}
                  </div>
                </div>
              )}
              <hr />
            </>
          )}
          {!selectedCentersAndApps && (
            <div>
              {monthlyBilling && isNewOrder && (
                <>
                  <div className="d-flex justify-content-between p-0 pr-4 pl-4 m-0 mt-2">
                    {!transitionOrder && (
                      <>
                        <div>
                          <ParagraphText
                            variant="lg"
                            color="thryv-gray-light-500"
                          >
                            Total Due Monthly
                          </ParagraphText>
                          <ParagraphText
                            variant="lg"
                            color="thryv-gray-light-500"
                          >
                            Next Payment {monthlyPayDate}
                          </ParagraphText>
                        </div>
                        <ParagraphText
                          variant="reg"
                          color="thryv-gray-light-500"
                        >
                          {/* $ {Math.max(monthlyTotal, 0)} */}
                          {formatPrice(
                            Math.max(monthlyTotal, 0),
                            1,
                            '',
                            countryIsoValue,
                            true,
                          )}
                          {/* {countryIsoValue} */}
                          {!isAus &&
                            !isNZ &&
                            '  * excludes taxes and incentives'}
                          {(isAus || isNZ) && '  * excludes incentives'}
                        </ParagraphText>
                      </>
                    )}
                  </div>
                  <div className="d-flex justify-content-between p-0 pr-4 pl-4 m-0 mt-2">
                    <ParagraphText variant="reg" color="thryv-gray-light-500">
                      * {formatPrice(monthlyTotal, 1, '', countryIsoValue)}
                      /billing period after all incentives expire.
                    </ParagraphText>
                  </div>
                </>
              )}
              {semiAnnuallyBilling && isNewOrder && (
                <>
                  <div className="d-flex justify-content-between p-0 pr-4 pl-4 m-0 mt-2">
                    <div>
                      <ParagraphText variant="lg" color="thryv-gray-light-500">
                        Total Due Semi-Annually
                      </ParagraphText>
                      <ParagraphText variant="lg" color="thryv-gray-light-500">
                        Next Payment {semiAnnuallyPayDate}
                      </ParagraphText>
                    </div>
                    <ParagraphText variant="reg" color="thryv-gray-light-500">
                      {formatPrice(
                        Math.max(semiAnnuallyTotal, 0),
                        1,
                        '',
                        countryIsoValue,
                      )}
                      {!isAus && !isNZ && '  * excludes taxes and incentives'}
                      {(isAus || isNZ) && '  * excludes incentives'}
                    </ParagraphText>
                  </div>
                  <div className="d-flex justify-content-between p-0 pr-4 pl-4 m-0 mt-2">
                    <ParagraphText variant="reg" color="thryv-gray-light-500">
                      *{' '}
                      {formatPrice(
                        Math.max(semiAnnuallyTotal, 0),
                        1,
                        '',
                        countryIsoValue,
                      )}
                      /billing period after all incentives expire.
                    </ParagraphText>
                  </div>
                </>
              )}
            </div>
          )}
          {isNewOrder && !selectedCentersAndApps && <hr />}
          {selectedCentersAndApps && (
            <BillingPromptContainer>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  rowGap: '12px',
                }}
              >
                <ParagraphText variant="reg" className="m-0">
                  Next Payment: {monthlyPayDate}
                </ParagraphText>
                {transitionOrder && (
                  <ParagraphText variant="sm" className="m-0">
                    *{formatPrice(ccTotal, 1, '', countryIsoValue)}/billing
                    period after all incentives expire
                  </ParagraphText>
                )}
              </div>
              <ParagraphText variant="reg">
                {formatPrice(
                  Math.max(nextAmountDue, 0),
                  1,
                  '',
                  countryIsoValue,
                )}
                {!isAus && !isNZ && '  * excludes taxes and incentives'}
                {(isAus || isNZ) && '  * excludes incentives'}
              </ParagraphText>
            </BillingPromptContainer>
          )}
        </div>
      </NewOrderLayout>
      {showProcessPurchaseErrorModal && (
        <Modal
          openOnLoad
          footer
          action
          variant="default"
          btnActionText="OK"
          btnAction={() => setShowProcessPurchaseErrorModal(false)}
          primaryAction={() => setShowProcessPurchaseErrorModal(false)}
          hideX
          btnType="primary"
          modalTestId="process-purchase-error-modal"
          // onClose={() => setShowProcessPurchaseErrorModal(false)}
        >
          <div style={{padding: '20px', textAlign: 'center'}}>
            {/* <div style={{marginBottom: '16px'}}>
              <Icon
                type="solid"
                variant="exclamationCircle"
                color="#dc3545"
                height="48"
                width="48"
              />
            </div> */}
            <h3
              style={{
                color: '#FF5000',
                marginBottom: '12px',
                fontSize: '20px',
                fontWeight: '600',
              }}
            >
              {processPurchaseErrorMessage?.startsWith("We couldn't confirm")
                ? 'Connection Lost'
                : 'Order Not Complete'}
            </h3>
            <p
              style={{
                whiteSpace: 'pre-wrap',
                marginTop: '16px',
                marginBottom: '0',
                color: '#333',
                fontSize: '14px',
                lineHeight: '1.6',
                maxHeight: '300px',
                overflowY: 'auto',
              }}
            >
              {processPurchaseErrorMessage?.startsWith(
                "We couldn't confirm",
              ) ? (
                <>
                  {
                    "We couldn't confirm the response from your browser. This is usually caused by a momentary issue with your internet connection (like a VPN, proxy, or weak Wi-Fi).\n\nIf the new subscriptions are already showing in Recurly or in the account, the purchase probably went through. "
                  }
                  <strong>Please don&apos;t try the payment again</strong>
                  {
                    ' until someone double-checks the order in OOE or Recurly.\n\nIf nothing has appeared yet, you can refresh the page and try again when you have a stable connection.'
                  }
                </>
              ) : (
                `It looks like there was an issue creating your subscriptions.
Please review the error message below and ask your manager to
check Recurly to confirm what's missing and help resolve the
problem.

${processPurchaseErrorMessage || ''}`
              )}
            </p>
          </div>
        </Modal>
      )}
    </>
  )
}

export default PaymentDetails
